/* eslint-disable */
<template>
  <div id="instructor-table-dynamic">
      <v-container v-if="!dynamicDataLoaded" class="loader">
        <v-progress-circular indeterminate size=70 :width="5"></v-progress-circular>
      </v-container>
      <!--my bulbs table-->
      <el-table
      v-if="(
        activeViewInstructor === 'My-Bulbs'
        && dynamicDataLoaded
      )"
      :data="bulbs.data"
      :cell-class-name="thumbnailColumn"
      :header-cell-class-name="sortClasses"
      @sort-change="sortChange"
      style="width: 100%"
      :max-height="maxHeight"
      :row-class-name="tableRowClassName"
      @selection-change="selectionChange"
      ref="myBulbsTable"
      >
        <el-table-column
          v-if="(
            isSchoolUser
            && !passbackLinking
          )"
          type="selection"
          width="55"
          align="center"
          :selectable="canSelectRow">
        </el-table-column>
        <el-table-column
          prop="thumbnail"
          label=""
          align="center"
          width="80"
          >
          <template slot-scope="scope" v-if="popoverReset">
            <el-popover
              trigger="click"
              placement="right"
              :disabled="(
                instructorAjaxing
                || selectedData.length > 0
                || passbackLinking
              )"
              width="100px"
              :tabindex="passbackLinking ? -1 : null"
              @show="handlePopoverShow">
              <div aria-live="polite">
                <div
                  v-if="(
                    LTIlaunch
                    && LTIdata.contentId === null
                    && scope.row.list_code != 0
                  )"
                  class="action-button"
                >
                  <v-btn
                    flat
                    text
                    class="branded-grey"
                    @click="handleDialogOpen({ type: 'lti' , data: scope.row })"
                  >
                    <img class="lms-img-sm" :src="LMSdata.img" style="margin-right: 8px" />
                      Set Bulb Link
                  </v-btn>
                </div>
                <div
                  v-if="(
                    [1, 2].includes(scope.row.bulb_role)
                    && LTIlaunch
                    && LTIdata.contentId == scope.row.id
                    && scope.row.list_code != 0
                  )"
                  class="action-button"
                >
                  <v-btn
                    flat
                    text
                    class="branded-grey"
                    @click="setDashModal({ type: 'confirmUnlink' })"
                  >
                    <img class="lms-img-sm" :src="LMSdata.img" style="margin-right: 8px" />
                      Unlink Bulb
                  </v-btn>
                </div>
                <div
                  v-if="passbackLinking"
                  class="action-button"
                >
                  <v-btn
                    flat
                    text
                    class="branded-grey"
                    @click="passbackContent({ bulbId: scope.row.id, bulbName: scope.row.name, type: 'bulb' })"
                  >
                    <v-icon small class="pr-2 bulbPickerIcon">exit_to_app</v-icon>
                      Passback Bulb
                  </v-btn>
                </div>
                <v-divider v-if="LTIlaunch"></v-divider>
                <div class="action-button" v-if="scope.row.list_code != 0 && [1, 2].includes(scope.row.bulb_role)">
                  <v-btn
                    @click="instructorData.migrated ? null : handleEditClick(scope.row)"
                    :disabled="!!instructorData.migrated"
                    flat
                    text
                    :class="instructorData.migrated ? null : 'branded-grey'"
                    tabindex="0"
                  >
                    <v-icon
                      small
                      class="pr-2"
                    >
                      edit
                    </v-icon>
                    Edit
                  </v-btn>
                </div>
                <div class="action-button" v-if="scope.row.list_code != 0 && !scope.row.lmb_id && [1, 2].includes(scope.row.bulb_role)">
                  <v-btn
                    @click="instructorData.migrated ? null : handleDialogOpen({type: 'bulbInfo' , data:scope.row})" tabindex="0"
                    :disabled="!!instructorData.migrated"
                    flat
                    text
                    :class="instructorData.migrated ? null : 'branded-grey'"
                  >
                    <v-icon
                      small
                      class="pr-2"
                    >
                      settings
                    </v-icon>
                    Settings
                  </v-btn>
                </div>
                <div class="action-button" v-if="scope.row.list_code != 0 && !scope.row.lmb_id">
                  <v-btn flat text  class="branded-grey"  @click="play(scope.row)" tabindex="0">
                    <v-icon small  style="padding-right: 8px;">play_circle_outline</v-icon>
                    Preview
                  </v-btn>
                </div>
                <div class="action-button" v-if="scope.row.list_code == 0 && !scope.row.lmb_id">
                  <v-btn flat text  class="branded-grey" @click="activateBulb(scope.row)" tabindex="0">
                    <v-icon small style="padding-right: 8px;">toggle_on</v-icon>
                    Activate
                  </v-btn>
                </div>
                <v-divider v-if="scope.row.list_code != 0 && !scope.row.lmb_id"></v-divider>
                <div class="action-button" v-if="!LTIlaunch && scope.row.list_code != 0">
                  <v-btn
                    @click="instructorData.migrated ? null : handleDialogOpen({type: 'assignMenu' , data: scope.row})"
                    :disabled="!!instructorData.migrated"
                    flat
                    text
                    :class="instructorData.migrated ? null : 'branded-grey'"
                  >
                    <v-icon
                      small
                      class="pr-2"
                    >
                      assignment
                    </v-icon>
                    Assign
                  </v-btn>
                </div>
                <div  class="action-button" v-if="scope.row.list_code != 0 && !scope.row.lmb_id">
                  <v-btn
                    @click="instructorData.migrated ? null : handleDialogOpen({type: 'shareMenu' , data: scope.row})"
                    :disabled="!!instructorData.migrated"
                    flat
                    text
                    :class="instructorData.migrated ? null : 'branded-grey'"
                  >
                    <v-icon
                      small
                      class="pr-2"
                    >
                      link
                    </v-icon>
                    Collaborate
                  </v-btn>
                </div>
                <div class="action-button" v-if="scope.row.list_code != 0 && !scope.row.lmb_id">
                  <v-btn
                    @click="instructorData.migrated ? null : handleDialogOpen({type: 'addToFolder' , data: scope.row})"
                    :disabled="!!instructorData.migrated"
                    flat
                    text
                    :class="instructorData.migrated ? null : 'branded-grey'"
                  >
                    <v-icon
                      small
                      class="pr-2"
                    >
                      folder
                    </v-icon>
                    Manage Folders
                  </v-btn>
                </div>
                <div class="action-button" v-if="scope.row.list_code != 0 && !scope.row.lmb_id && instructorType != 'free'">
                  <v-btn
                    @click="instructorData.migrated ? null : handleDialogOpen({ type:'broadcast' , data: scope.row})"
                    :disabled="!!instructorData.migrated"
                    flat
                    text
                    :class="instructorData.migrated ? null : 'branded-grey'"
                  >
                    <v-icon
                      small
                      class="pr-2"
                    >
                      rss_feed
                    </v-icon>
                    Broadcast
                  </v-btn>
                </div>
                <v-divider v-if="scope.row.list_code != 0 && !scope.row.lmb_id"></v-divider>
                <div class="action-button" v-if="scope.row.list_code != 0">
                  <v-btn flat text  class="branded-grey"  @click="handleDialogOpen({type:'monitor' , data:scope.row})" tabindex="0">
                    <v-icon small  style="padding-right: 8px;">view_list</v-icon>
                    Monitor
                  </v-btn>
                </div>
                <div v-if="scope.row.bulb_role === 1" class="action-button"> 
                  <v-btn flat text class="branded-grey" @click="setDashModal({ type: 'sectionInfo', bulbId: scope.row.id })">
                    <v-icon small class="pr-1">info</v-icon>
                    Bulb Details
                  </v-btn>
                </div>
                <div class="action-button" v-if="scope.row.list_code != 0 && !scope.row.lmb_id && [1].includes(scope.row.bulb_role)">
                  <v-btn flat text  class="branded-grey"  @click="handleDialogOpen({type:'export', data:{analytics:true, bulb_name:scope.row.name, bulb_id:scope.row.id}})" tabindex="0">
                    <v-icon small  style="padding-right: 8px;">cloud_download</v-icon>
                    Export Analytics
                  </v-btn>
                </div>
                <div class="action-button" v-if="scope.row.list_code != 0 && !scope.row.lmb_id">
                  <v-btn flat text  class="branded-grey"  @click="exportWorksheet(scope.row.id)" tabindex="0">
                    <v-icon small  style="padding-right: 8px;">description</v-icon>
                    Export Worksheet
                  </v-btn>
                </div>
                <div class="action-button" v-if="scope.row.list_code != 0">
                  <v-btn
                    @click="instructorData.migrated ? null : handleDialogOpen({type: 'copyMenu' , data: scope.row})"
                    :disabled="!!instructorData.migrated"
                    flat
                    text
                    :class="instructorData.migrated ? null : 'branded-grey'"
                  >
                    <v-icon
                      small
                      class="pr-2"
                    >
                      file_copy
                    </v-icon>
                    Copy
                  </v-btn>
                </div>
                <v-divider></v-divider>
                <div class="action-button-delete">
                  <v-btn flat text  class="branded-grey"  @click="handleDialogOpen({type:'remove' , data:scope.row})" tabindex="0" v-if="scope.row.bulb_role === 1">
                    <v-icon small style="padding-right: 8px;">delete</v-icon>
                    Delete
                  </v-btn>
                  <v-btn flat text  class="branded-grey"  @click="handleDialogOpen({type:'remove' , data:scope.row})" tabindex="0" v-else>
                    <v-icon small style="padding-right: 8px;">person_add_disabled</v-icon>
                    Remove Bulb
                  </v-btn>
                </div>
              </div>
              <div slot="reference" class="column" style="height:50px;" tabindex="0" @keyup.enter="">
                <v-responsive :aspect-ratio="16/9"  height="36px" width="64px" max-height="36px" max-width="64px" >
                  <button aria-label="Bulb menu" class="thumbnail-wrapper"><img style="width: 100%; height: 100%" :src="scope.row.thumbnail"/></button>
                </v-responsive>
              </div>
            </el-popover>
          </template>
        </el-table-column>
        <el-table-column
        align="center"
        width="50"
        v-if="isSchoolUser"
        >
          <template slot-scope="scope">
            <Tooltip v-if="scope.row.bulb_role === 2" top>
              <v-icon>create</v-icon>
              <template v-slot:text>
                You are a Co-Owner of this bulb
              </template>
            </Tooltip>
            <Tooltip v-else-if="scope.row.bulb_role === 3" top>
              <v-icon>remove_red_eye</v-icon>
              <template v-slot:text>
                You are a Facilitator of this bulb.
              </template>
            </Tooltip>
          </template>
        </el-table-column>
        <el-table-column
          sortable="custom"
          prop="name"
          label="Bulb"
          min-width= "200">
          <template slot-scope="scope" >
            <div class='row-start'>
              <Tooltip v-if="passbackLinking" top style="margin-right: 5px;">
                <v-btn
                  tabindex="1"
                  icon
                  @click="passbackContent({bulbId: scope.row.id, bulbName: scope.row.name, type: 'bulb'})"
                  :aria-label="`Click to add bulb ${scope.row.name} to module`">
                  <v-icon class="selectable bulbPickerIcon">exit_to_app</v-icon>
                </v-btn>
                <template v-slot:text>
                  Select Bulb
                </template>
              </Tooltip>
              <Tooltip v-if="LTIlaunch && (LTIdata.contentId === null)" top style="margin-right: 5px;">
                <img  @click="handleDialogOpen({type:'lti' , data:scope.row})" class="lms-img selectable" :src="LMSdata.img">
                <template v-slot:text>
                  Set Bulb Link
                </template>
              </Tooltip>
              <Tooltip top>
                <span
                  :class="[ isSafari ? 'safari-bulb-name-truncate' : 'bulb-name-truncate' ]"
                  :ref="scope.row.id">
                  {{scope.row.name}}
                </span>
                <template v-slot:text>
                  {{scope.row.name}}
                </template>
              </Tooltip>
              <Tooltip v-if="[1, 2].includes(scope.row.bulb_role) && LTIdata.contentId == scope.row.id" top>
                <img  @click="setDashModal({ type: 'confirmUnlink' })" class="lms-img selectable" :src="LMSdata.img" style="margin-left: 18px;">
                <template v-slot:text>
                  Unlink Bulb
                </template>
              </Tooltip>
            </div>
          </template>
        </el-table-column>
        <el-table-column
          min-width="350"
          align="center"
          prop=""
          label="Tags"
          >
          <template slot-scope="scope">
            <div v-if="!scope.row.lmb_id">
              <div  class="bulbs-tag-container justify-center" v-if="updateTags && scope.row.tags.length > 0">
               <el-tag  @click="setKeywordFilter(tag)" v-for="(tag, index) in scope.row.tags" v-if="(showAllTags[scope.row.id]) ? index > -1 : index <= 2" :key="index" :style="tagStyle(tag)">{{tag.text}}</el-tag>
               <div class="edit-tags" v-if="scope.row.tags.length <= 3 && [1, 2].includes(scope.row.bulb_role) && !passbackLinking">
                 <span  class="selectable" @click="handleDialogOpen({type:'bulbInfo' , data:scope.row})" >Edit Tags</span>
               </div>
               <div class="edit-tags" v-if="scope.row.tags.length > 3 && showAllTags[scope.row.id] && [1, 2].includes(scope.row.bulb_role) && !passbackLinking">
                 <span  class="selectable" @click="handleDialogOpen({type:'bulbInfo' , data:scope.row})" >Edit Tags</span>
               </div>
               <el-tag  @click="showTags(scope.row)" v-show="scope.row.tags.length > 3 && !showAllTags[scope.row.id]"  type="info" style="margin:5px; background-color:#fff; border-color: #fff;" class="cursor">...</el-tag>
               <el-tag  @click="showTags(scope.row)" v-show="scope.row.tags.length > 3 && showAllTags[scope.row.id]" type="info" style="margin:5px; background-color:#fff; border-color: #fff;" class="cursor">
                 <v-icon small>clear</v-icon>
               </el-tag>
             </div>
             <span v-if="scope.row.tags.length === 0 && scope.row.list_code != 0 && [1, 2].includes(scope.row.bulb_role) && !passbackLinking" class="selectable" aria-label="Add Tags" tabIndex="0" @click="handleDialogOpen({type:'bulbInfo' , data:scope.row})" >Add Tags</span> 
             <Tooltip v-if="scope.row.list_code == 0" top>
              <span>Activate Bulb</span>
              <template v-slot:text>
                Contact help@playposit.org to activate this bulb
              </template>
             </Tooltip>
            </div>
          </template>
        </el-table-column>
        <el-table-column
          width="130"
          header-align="center"
          align="center"
          sortable="custom"
          prop="updated"
          label="Last Modified">
        </el-table-column>
        <el-table-column
          width="100"
          header-align="center"
          align="center"
          sortable="custom"
          prop="view_count"
          label="Views">
        </el-table-column>
        <el-table-column
          header-align="center"
          align="center"
          width="100"
          prop=""
          v-if="selectedData.length === 0 && !passbackLinking"
          label="Actions">
          <template slot-scope="scope" v-if="popoverReset">
            <el-popover trigger="click" placement="left" :disabled="instructorAjaxing || selectedData.length > 0" width="100px" @show="handlePopoverShow">
              <div aria-live="polite">
                <div class="action-button" v-if="LTIlaunch && LTIdata.contentId === null && scope.row.list_code != 0">
                  <v-btn flat text  class="branded-grey"  @click="handleDialogOpen({type:'lti' , data:scope.row})" >
                    <img class="lms-img-sm" :src="LMSdata.img" style="margin-right: 8px;">
                    Set Bulb Link
                  </v-btn>
                </div>
                <div class="action-button" v-if="[1, 2].includes(scope.row.bulb_role) && LTIlaunch && LTIdata.contentId == scope.row.id && scope.row.list_code != 0">
                  <v-btn flat text  class="branded-grey"  @click="setDashModal({ type: 'confirmUnlink' })" >
                    <img class="lms-img-sm" :src="LMSdata.img" style="margin-right: 8px;">
                    Unlink Bulb
                  </v-btn>
                </div>
                <div
                  class="action-button"
                  v-if="passbackLinking">
                  <v-btn
                    flat
                    @click="passbackBulb({bulbId: scope.row.id, bulbName: scope.row.name})">
                      <v-icon small class="pr-2 bulbPickerIcon">exit_to_app</v-icon>
                      Passback Bulb
                    @click="passbackContent({bulbId: scope.row.id, bulbName: scope.row.name, type: 'bulb'})">
                    <v-icon small class="pr-2 bulbPickerIcon">exit_to_app</v-icon>
                    Passback Bulb
                  </v-btn>
                </div>
                <v-divider v-if="LTIlaunch"></v-divider>
                <div class="action-button" v-if="scope.row.list_code != 0 && [1, 2].includes(scope.row.bulb_role)">
                  <v-btn
                    @click="instructorData.migrated ? null : handleEditClick(scope.row)"
                    :disabled="!!instructorData.migrated"
                    flat
                    text
                    :class="instructorData.migrated ? null : 'branded-grey'"
                    tabindex="0"
                  >
                    <v-icon
                      small
                      class="pr-2"
                    >
                      edit
                    </v-icon>
                    Edit
                  </v-btn>
                </div>
                <div class="action-button" v-if="scope.row.list_code != 0 && !scope.row.lmb_id && [1, 2].includes(scope.row.bulb_role)">
                  <v-btn
                    @click="instructorData.migrated ? null : handleDialogOpen({type: 'bulbInfo' , data:scope.row})" tabindex="0"
                    :disabled="!!instructorData.migrated"
                    flat
                    text
                    :class="instructorData.migrated ? null : 'branded-grey'"
                  >
                    <v-icon
                      small
                      class="pr-2"
                    >
                      settings
                    </v-icon>
                    Settings
                  </v-btn>
                </div>
                <div class="action-button" v-if="scope.row.list_code != 0 && !scope.row.lmb_id">
                  <v-btn flat text  class="branded-grey"  @click="play(scope.row)" tabindex="0">
                    <v-icon small  style="padding-right: 8px;">play_circle_outline</v-icon>
                    Preview
                  </v-btn>
                </div>
                <div class="action-button" v-if="scope.row.list_code == 0 && !scope.row.lmb_id">
                  <v-btn flat text  class="branded-grey" @click="activateBulb(scope.row)" tabindex="0">
                    <v-icon small style="padding-right: 8px;">toggle_on</v-icon>
                    Activate
                  </v-btn>
                </div>
                <v-divider v-if="scope.row.list_code != 0 && !scope.row.lmb_id"></v-divider>
                <div class="action-button" v-if="!LTIlaunch && scope.row.list_code != 0">
                  <v-btn
                    @click="instructorData.migrated ? null : handleDialogOpen({type: 'assignMenu' , data: scope.row})"
                    :disabled="!!instructorData.migrated"
                    flat
                    text
                    :class="instructorData.migrated ? null : 'branded-grey'"
                  >
                    <v-icon
                      small
                      class="pr-2"
                    >
                      assignment
                    </v-icon>
                    Assign
                  </v-btn>
                </div>
                <div  class="action-button" v-if="scope.row.list_code != 0 && !scope.row.lmb_id">
                  <v-btn
                    @click="instructorData.migrated ? null : handleDialogOpen({type: 'shareMenu' , data: scope.row})"
                    :disabled="!!instructorData.migrated"
                    flat
                    text
                    :class="instructorData.migrated ? null : 'branded-grey'"
                  >
                    <v-icon
                      small
                      class="pr-2"
                    >
                      link
                    </v-icon>
                    Collaborate
                  </v-btn>
                </div>
                <div class="action-button" v-if="scope.row.list_code != 0 && !scope.row.lmb_id">
                  <v-btn
                    @click="instructorData.migrated ? null : handleDialogOpen({type: 'addToFolder' , data: scope.row})"
                    :disabled="!!instructorData.migrated"
                    flat
                    text
                    :class="instructorData.migrated ? null : 'branded-grey'"
                  >
                    <v-icon
                      small
                      class="pr-2"
                    >
                      folder
                    </v-icon>
                    Manage Folders
                  </v-btn>
                </div>
                <div class="action-button" v-if="scope.row.list_code != 0 && !scope.row.lmb_id && instructorType != 'free'">
                  <v-btn
                    @click="instructorData.migrated ? null : handleDialogOpen({type: 'broadcast' , data: scope.row})"
                    :disabled="!!instructorData.migrated"
                    flat
                    text
                    :class="instructorData.migrated ? null : 'branded-grey'"
                  >
                    <v-icon
                      small
                      class="pr-2"
                    >
                      rss_feed
                    </v-icon>
                    Broadcast
                  </v-btn>
                </div>
                <v-divider v-if="scope.row.list_code != 0 && !scope.row.lmb_id"></v-divider>
                <div class="action-button" v-if="scope.row.list_code != 0">
                  <v-btn flat text  class="branded-grey"  @click="handleDialogOpen({type:'monitor' , data:scope.row})" tabindex="0">
                    <v-icon small  style="padding-right: 8px;">view_list</v-icon>
                    Monitor
                  </v-btn>
                </div>
                <div v-if="scope.row.bulb_role === 1" class="action-button"> 
                  <v-btn flat text class="branded-grey" @click="setDashModal({ type: 'sectionInfo', bulbId: scope.row.id })">
                    <v-icon small class="pr-1">info</v-icon>
                    Bulb Details
                  </v-btn>
                </div>
                <div class="action-button" v-if="scope.row.list_code != 0 && !scope.row.lmb_id && [1].includes(scope.row.bulb_role)">
                  <v-btn flat text  class="branded-grey"  @click="handleDialogOpen({type:'export', data:{analytics:true, bulb_name:scope.row.name, bulb_id:scope.row.id}})" tabindex="0">
                    <v-icon small  style="padding-right: 8px;">cloud_download</v-icon>
                    Export Analytics
                  </v-btn>
                </div>
                <div class="action-button" v-if="scope.row.list_code != 0 && !scope.row.lmb_id">
                  <v-btn flat text  class="branded-grey"  @click="exportWorksheet(scope.row.id)" tabindex="0">
                    <v-icon small  style="padding-right: 8px;">description</v-icon>
                    Export Worksheet
                  </v-btn>
                </div>
                <div class="action-button" v-if="scope.row.list_code != 0">
                  <v-btn
                    @click="instructorData.migrated ? null : handleDialogOpen({type: 'copyMenu' , data: scope.row})"
                    :disabled="!!instructorData.migrated"
                    flat
                    text
                    :class="instructorData.migrated ? null : 'branded-grey'"
                  >
                    <v-icon
                      small
                      class="pr-2"
                    >
                      file_copy
                    </v-icon>
                    Copy
                  </v-btn>
                </div>
                <v-divider></v-divider>
                <div class="action-button-delete">
                  <v-btn flat text  class="branded-grey"  @click="handleDialogOpen({type:'remove' , data:scope.row})" tabindex="0" v-if="scope.row.bulb_role === 1">
                    <v-icon small style="padding-right: 8px;">delete</v-icon>
                    Delete
                  </v-btn>
                  <v-btn flat text  class="branded-grey"  @click="handleDialogOpen({type:'remove' , data:scope.row})" tabindex="0" v-else>
                    <v-icon small style="padding-right: 8px;">person_add_disabled</v-icon>
                    Remove Bulb
                  </v-btn>
                </div>
              </div>
              <v-btn flat class="no-hover" slot="reference" aria-label="Menu">
                <v-icon class="hover-white cursor padding branded-text">more_vert</v-icon>
              </v-btn>
            </el-popover>
          </template>
        </el-table-column>
        <template slot="empty">
          <div class="column">
            <span v-if="queryParamsInstructors.search === '' && filterString == ''" class="selectable branded-text" @click="newBulb" style="text-decoration:none; height:45px;">
              Create your first bulb
            </span>
            <!--<span v-if="queryParamsInstructors.search === '' && filterString == '' && (legacy.legacy && !legacy.importedLessons)" class="selectable branded-text" @click="handleDialogOpen({type:'confirm' , data:{type:'import'}})" style="text-decoration:none; ">-->
            <!--  Don't see your bulbs? Import now!-->
            <!--</span>-->
            <span v-if="queryParamsInstructors.search != '' || filterString != ''">
              No Bulbs
            </span>
          </div>
        </template>
      </el-table>

      <!--folders table-->
      <el-table
        v-if="activeViewInstructor === 'Folders' && dynamicDataLoaded"
        :data="folders.data"
        :header-cell-class-name="sortClasses"
        style="width: 100%"
        @sort-change="sortChange"
        :max-height="maxHeight"
        @selection-change="selectionChange"
      >
        <el-table-column
          v-if="showFolderBatchSelection"
          type="selection"
          width="55"
          align="center"
        >
        </el-table-column>
        <el-table-column
          header-align="center"
          align="center"
          width="50"
          prop=""
          label="">
          <template slot-scope="scope">
            <div class="row-center">
              <v-icon :color="scope.row.default_color" large tabIndex="0" aria-label="Open folder" class="cursor" @click="setNavData(['Folder', {folder_id:scope.row.id}, scope.row.name, null, null])">folder</v-icon>
            </div>
          </template>
        </el-table-column>
        <el-table-column
          min-width= "200"
          sortable="custom"
          prop="name"
          label="Name">
          <template slot-scope="scope">
            <div class="row-start" style="width: 500px">
              <Tooltip top>
                <span
                  class="selectable"
                  :class="[ isSafari ? 'safari-bulb-name-truncate-folders-table' : 'bulb-name-truncate' ]"
                  :ref="scope.row.id"
                  @click="setNavData(['Folder', {folder_id:scope.row.id}, scope.row.name, null, null])">
                  {{scope.row.name}}
                </span>
                <template v-slot:text>
                  {{scope.row.name}}
                </template>
              </Tooltip>
            </div>
          </template>
        </el-table-column>
        <el-table-column
          width="150"
          sortable="custom"
          prop="updated"
          label="Last Modified">
        </el-table-column>
        <el-table-column
          header-align="center"
          align="center"
          width="100"
          prop=""
          label="Actions">
          <template slot-scope="scope">
            <el-popover
              trigger="click"
              placement="left"
              :disabled="instructorAjaxing"
              width="100px"
              v-if="popoverReset"
              @show="handlePopoverShow">
              <div>
                <div class="action-button">
                  <v-btn
                    @click="instructorData.migrated ? null : handleDialogOpen({type: 'editFolder' , data: scope.row})"
                    :disabled="!!instructorData.migrated"
                    flat
                    text
                    :class="instructorData.migrated ? null : 'branded-grey'"
                    tabindex="0"
                  >
                    <v-icon
                      small
                      class="pr-2"
                    >
                      edit
                    </v-icon>
                    Edit
                  </v-btn>
                </div>
                <div  class="action-button">
                  <v-btn
                    @click="instructorData.migrated ? null : handleDialogOpen({type: 'shareFolder' , data: scope.row})"
                    :disabled="!!instructorData.migrated"
                    flat
                    text
                    :class="instructorData.migrated ? null : 'branded-grey'"
                    tabindex="0"
                  >
                    <v-icon
                      small
                      class="pr-2"
                    >
                      link
                    </v-icon>
                    Share
                  </v-btn>
                </div>
                <div class="action-button">
                  <v-btn
                    @click="instructorData.migrated ? null : handleDialogOpen({type: 'copyFolder' , data: {data: scope.row, subfolder: false}})"
                    :disabled="!!instructorData.migrated"
                    flat
                    text
                    :class="instructorData.migrated ? null : 'branded-grey'"
                    tabindex="0"
                  >
                    <v-icon
                      small
                      class="pr-2"
                    >
                      file_copy
                    </v-icon>
                    Copy
                  </v-btn>
                </div>
                <v-divider></v-divider>
                <div class="action-button-delete" >
                  <v-btn flat text  class="branded-grey"  @click="handleDialogOpen({type:'remove' , data:scope.row})" tabindex="0">
                    <v-icon small style="padding-right: 8px;">delete</v-icon>
                    Delete
                  </v-btn>
                </div>
              </div>
              <v-btn flat class="no-hover" slot="reference" >
                <v-icon class="hover-white cursor padding branded-text">more_vert</v-icon>
              </v-btn>
            </el-popover>
          </template>
        </el-table-column>
        <template slot="empty">
          <div class="column">
            <span v-if="queryParamsInstructors.search === ''" class="selectable branded-text" @click="handleDialogOpen({type:'addFolder', data:{}})" style="text-decoration:none; height:45px;">
              Create your first folder
            </span>
            <span v-if="queryParamsInstructors.search === '' && (!legacy.importedUnits && legacy.legacy && legacy.importedLessons)" class="selectable branded-text" @click="handleDialogOpen({type:'confirm' , data:{type:'importunits'}})" style="text-decoration:none; ">
              Don't see your folders/units? Import now!
            </span>
            <span v-if="queryParamsInstructors.search != ''">
              No Folders
            </span>
          </div>
        </template>
      </el-table>

      <!--folder table-->
      <el-table
      v-if="activeViewInstructor === 'Folder' && dynamicDataLoaded"
      :data="singlefolder.data"
      :header-cell-class-name="sortClasses"
      style="width: 100%"
      @sort-change="sortChange"
      :max-height="maxHeight"
      @selection-change="selectionChange"
      >
      <el-table-column
          v-if="showFolderBatchSelection"
          type="selection"
          width="55"
          align="center"
        >
      </el-table-column>
        <el-table-column
          header-align="center"
          align="center"
          width="100"
          prop=""
          label="">
          <template slot-scope="scope">
            <div class="row-center">
              <v-icon
                v-if="scope.row.isFolder == 1"
                large
                :color="scope.row.default_color"
                class="cursor"
                tabIndex="0"
                aria-label="Open folder"
                @click="subfolderNav({name:scope.row.name, id:scope.row.id})">
                folder
              </v-icon>
              <v-responsive
                v-if="scope.row.isFolder == 0"
                :aspect-ratio="16/9"
                height="36px"
                width="64px"
                max-height="36px"
                max-width="64px">
                <div class="thumbnail-wrapper">
                  <img style="width: 100%; height: 100%" :src="scope.row.thumbnail"/>
                </div>
              </v-responsive>
            </div>
          </template>
        </el-table-column>
        <el-table-column
          min-width= "200"
          sortable="custom"
          prop="name"
          label="Name">
          <template slot-scope="scope">
            <div class="row-start" style="width: 500px">
            <Tooltip top>
              <span
                v-if="scope.row.isFolder == 1"
                class="selectable"
                :class="[ isSafari ? 'safari-bulb-name-truncate' : 'bulb-name-truncate' ]"
                @click="subfolderNav({name:scope.row.name, id:scope.row.id})">
                {{ scope.row.name }}
              </span>
              <span
                v-else-if="scope.row.isFolder == 0"
                :class="[ isSafari ? 'safari-bulb-name-truncate' : 'bulb-name-truncate' ]">
                {{ scope.row.name }}
              </span>
              <template v-slot:text>
                {{ scope.row.name }}
              </template>
            </Tooltip>
          </div>
          </template>
        </el-table-column>
        <el-table-column
          width="150"
          sortable="custom"
          prop="updated"
          label="Last Modified">
        </el-table-column>
        <el-table-column
          header-align="center"
          align="center"
          width="100"
          prop=""
          label="Actions">
          <template slot-scope="scope">
            <el-popover
              trigger="click"
              placement="left"
              :disabled="instructorAjaxing"
              width="100px"
              v-if="popoverReset"
              @show="handlePopoverShow">
              <div v-if="scope.row.isFolder == 1" aria-live="polite">
                <div class="action-button" >
                  <v-btn
                    @click="instructorData.migrated ? null : handleDialogOpen({type: 'editFolder' , data: scope.row})"
                    :disabled="!!instructorData.migrated"
                    flat
                    text
                    :class="instructorData.migrated ? null : 'branded-grey'"
                    tabindex="0"
                  >
                    <v-icon
                      small
                      class="pr-2"
                    >
                      edit
                    </v-icon>
                    Edit
                  </v-btn>
                </div>
                <div class="action-button">
                  <v-btn
                    @click="instructorData.migrated ? null : handleDialogOpen({type: 'copyFolder' , data: {data: scope.row, subfolder: false}})"
                    :disabled="!!instructorData.migrated"
                    flat
                    text
                    :class="instructorData.migrated ? null : 'branded-grey'"
                    tabindex="0"
                  >
                    <v-icon
                      small
                      class="pr-2"
                    >
                      file_copy
                    </v-icon>
                    Copy
                  </v-btn>
                </div>
                <v-divider></v-divider>
                <div class="action-button-delete" >
                  <v-btn flat text  class="branded-grey"  @click="handleDialogOpen({type:'remove' , data:scope.row})" tabindex="0">
                    <v-icon small style="padding-right: 8px;">delete</v-icon>
                    Delete
                  </v-btn>
                </div>
              </div>
              <div v-if="scope.row.isFolder == 0">
                <div class="action-button" v-if="scope.row.list_code != 0">
                  <v-btn
                    @click="instructorData.migrated ? null : handleEditClick(scope.row)"
                    :disabled="!!instructorData.migrated"
                    flat
                    text
                    :class="instructorData.migrated ? null : 'branded-grey'"
                    tabindex="0"
                  >
                    <v-icon
                      small
                      class="pr-2"
                    >
                      edit
                    </v-icon>
                    Edit
                  </v-btn>
                </div>
                <div class="action-button" v-if="scope.row.list_code != 0 && !scope.row.lmb_id">
                  <v-btn
                    @click="instructorData.migrated ? null : handleDialogOpen({type: 'bulbInfo' , data:scope.row})" tabindex="0"
                    :disabled="!!instructorData.migrated"
                    flat
                    text
                    :class="instructorData.migrated ? null : 'branded-grey'"
                  >
                    <v-icon
                      small
                      class="pr-2"
                    >
                      settings
                    </v-icon>
                    Settings
                  </v-btn>
                </div>
                <div class="action-button" v-if="scope.row.list_code != 0 && !scope.row.lmb_id">
                  <v-btn flat text  class="branded-grey"  @click="play(scope.row)" tabindex="0">
                    <v-icon small  style="padding-right: 8px;">play_circle_outline</v-icon>
                    Preview
                  </v-btn>
                </div>
                <div class="action-button" v-if="scope.row.list_code == 0 && !scope.row.lmb_id">
                  <v-btn flat text  class="branded-grey" @click="activateBulb(scope.row)" tabindex="0">
                    <v-icon small style="padding-right: 8px;">toggle_on</v-icon>
                    Activate
                  </v-btn>
                </div>
                <v-divider v-if="scope.row.list_code != 0 && !scope.row.lmb_id"></v-divider>
                <div class="action-button" v-if="!LTIlaunch && scope.row.list_code != 0">
                  <v-btn
                    @click="instructorData.migrated ? null : handleDialogOpen({type: 'assignMenu' , data: scope.row})"
                    :disabled="!!instructorData.migrated"
                    flat
                    text
                    :class="instructorData.migrated ? null : 'branded-grey'"
                  >
                    <v-icon
                      small
                      class="pr-2"
                    >
                      assignment
                    </v-icon>
                    Assign
                  </v-btn>
                </div>
                <div  class="action-button" v-if="scope.row.list_code != 0 && !scope.row.lmb_id">
                  <v-btn
                    @click="instructorData.migrated ? null : handleDialogOpen({type: 'shareMenu' , data: scope.row})"
                    :disabled="!!instructorData.migrated"
                    flat
                    text
                    :class="instructorData.migrated ? null : 'branded-grey'"
                  >
                    <v-icon
                      small
                      class="pr-2"
                    >
                      link
                    </v-icon>
                    Collaborate
                  </v-btn>
                </div>
                <div class="action-button" v-if="scope.row.list_code != 0 && !scope.row.lmb_id && instructorType != 'free'">
                  <v-btn
                    @click="instructorData.migrated ? null : handleDialogOpen({type: 'broadcast' , data: scope.row})"
                    :disabled="!!instructorData.migrated"
                    flat
                    text
                    :class="instructorData.migrated ? null : 'branded-grey'"
                  >
                    <v-icon
                      small
                      class="pr-2"
                    >
                      rss_feed
                    </v-icon>
                    Broadcast
                  </v-btn>
                </div>
                <v-divider v-if="scope.row.list_code != 0 && !scope.row.lmb_id"></v-divider>
                <div class="action-button" v-if="scope.row.list_code != 0">
                  <v-btn flat text  class="branded-grey"  @click="handleDialogOpen({type:'monitor' , data:scope.row})" tabindex="0">
                    <v-icon small  style="padding-right: 8px;">view_list</v-icon>
                    Monitor
                  </v-btn>
                </div>
                <div class="action-button" v-if="scope.row.list_code != 0 && !scope.row.lmb_id">
                  <v-btn flat text  class="branded-grey"  @click="handleDialogOpen({type:'export', data:{analytics:true, bulb_name:scope.row.name, bulb_id:scope.row.id}})" tabindex="0">
                    <v-icon small  style="padding-right: 8px;">cloud_download</v-icon>
                    Export Analytics
                  </v-btn>
                </div>
                <v-divider></v-divider>
                <div class="action-button-delete" >
                  <v-btn flat text  class="branded-grey"  @click="handleDialogOpen({type:'remove' , data:scope.row})" tabindex="0">
                    <v-icon small style="padding-right: 8px;">delete</v-icon>
                    Remove From Folder
                  </v-btn>
                </div>
              </div>
              <v-btn flat class="no-hover" slot="reference" >
                <v-icon class="hover-white cursor padding branded-text">more_vert</v-icon>
              </v-btn>
            </el-popover>
          </template>
        </el-table-column>
        <template slot="empty">
          <div class="column">
            <span v-if="queryParamsInstructors.search != ''">
              No Data matching search
            </span>
            <span v-if="queryParamsInstructors.search === ''">
              No Data in folder
            </span>
          </div>
        </template>
      </el-table>

      <!--subfolder table-->
      <el-table
      v-if="activeViewInstructor === 'Subfolder' && dynamicDataLoaded"
      :data="subfolder.data"
      :header-cell-class-name="sortClasses"
      style="width: 100%"
      @sort-change="sortChange"
      :max-height="maxHeight"
      >
        <el-table-column
          header-align="center"
          align="center"
          width="100"
          prop=""
          label="">
          <template slot-scope="scope">
            <div class="row-center">
              <v-responsive :aspect-ratio="16/9"  height="36px" width="64px" max-height="36px" max-width="64px" >
                <button class="thumbnail-wrapper"><img style="width: 100%; height: 100%" :src="scope.row.thumbnail"/></button>
              </v-responsive>
            </div>
          </template>
        </el-table-column>
        <el-table-column
          min-width= "200"
          sortable="custom"
          prop="name"
          label="Name">
          <template slot-scope="scope">
            <div class="row-start" style="width: 500px">
            <Tooltip top>
              <span :class="[ isSafari ? 'safari-bulb-name-truncate' : 'bulb-name-truncate' ]">
                {{scope.row.name}}
              </span>
              <template v-slot:text>
                {{scope.row.name}}
              </template>
            </Tooltip>
          </div>
          </template>
        </el-table-column>
        <el-table-column
          width="150"
          sortable="custom"
          prop="updated"
          label="Last Modified">
        </el-table-column>
        <el-table-column
          header-align="center"
          align="center"
          width="100"
          prop=""
          label="Actions">
          <template slot-scope="scope">
            <el-popover
              trigger="click"
              placement="left"
              :disabled="instructorAjaxing"
              width="100px"
              v-if="popoverReset"
              @show="handlePopoverShow">
              <div aria-live="polite">
                <div class="action-button" v-if="scope.row.list_code != 0">
                  <v-btn
                    @click="instructorData.migrated ? null : handleEditClick(scope.row)"
                    :disabled="!!instructorData.migrated"
                    flat
                    text
                    :class="instructorData.migrated ? null : 'branded-grey'"
                    tabindex="0"
                  >
                    <v-icon
                      small
                      class="pr-2"
                    >
                      edit
                    </v-icon>
                    Edit
                  </v-btn>
                </div>
                <div class="action-button" v-if="scope.row.list_code != 0 && !scope.row.lmb_id">
                  <v-btn
                    @click="instructorData.migrated ? null : handleDialogOpen({type: 'bulbInfo' , data:scope.row})" tabindex="0"
                    :disabled="!!instructorData.migrated"
                    flat
                    text
                    :class="instructorData.migrated ? null : 'branded-grey'"
                  >
                    <v-icon
                      small
                      class="pr-2"
                    >
                      settings
                    </v-icon>
                    Settings
                  </v-btn>
                </div>
                <div class="action-button" v-if="scope.row.list_code != 0 && !scope.row.lmb_id">
                  <v-btn flat text  class="branded-grey"  @click="play(scope.row)" tabindex="0">
                    <v-icon small  style="padding-right: 8px;">play_circle_outline</v-icon>
                    Preview
                  </v-btn>
                </div>
                <div class="action-button" v-if="scope.row.list_code == 0 && !scope.row.lmb_id">
                  <v-btn flat text  class="branded-grey" @click="activateBulb(scope.row)" tabindex="0">
                    <v-icon small style="padding-right: 8px;">toggle_on</v-icon>
                    Activate
                  </v-btn>
                </div>
                <v-divider v-if="scope.row.list_code != 0 && !scope.row.lmb_id"></v-divider>
                <div class="action-button" v-if="!LTIlaunch && scope.row.list_code != 0">
                  <v-btn
                    @click="instructorData.migrated ? null : handleDialogOpen({type: 'assignMenu' , data: scope.row})"
                    :disabled="!!instructorData.migrated"
                    flat
                    text
                    :class="instructorData.migrated ? null : 'branded-grey'"
                  >
                    <v-icon
                      small
                      class="pr-2"
                    >
                      assignment
                    </v-icon>
                    Assign
                  </v-btn>
                </div>
                <div  class="action-button" v-if="scope.row.list_code != 0 && !scope.row.lmb_id">
                  <v-btn
                    @click="instructorData.migrated ? null : handleDialogOpen({type: 'shareMenu' , data: scope.row})"
                    :disabled="!!instructorData.migrated"
                    flat
                    text
                    :class="instructorData.migrated ? null : 'branded-grey'"
                  >
                    <v-icon
                      small
                      class="pr-2"
                    >
                      link
                    </v-icon>
                    Collaborate
                  </v-btn>
                </div>
                <div class="action-button" v-if="scope.row.list_code != 0 && !scope.row.lmb_id && instructorType != 'free'">
                  <v-btn
                    @click="instructorData.migrated ? null : handleDialogOpen({ type:'broadcast' , data: scope.row})"
                    :disabled="!!instructorData.migrated"
                    flat
                    text
                    :class="instructorData.migrated ? null : 'branded-grey'"
                  >
                    <v-icon
                      small
                      class="pr-2"
                    >
                      rss_feed
                    </v-icon>
                    Broadcast
                  </v-btn>
                </div>
                <v-divider v-if="scope.row.list_code != 0 && !scope.row.lmb_id"></v-divider>
                <div class="action-button" v-if="scope.row.list_code != 0">
                  <v-btn flat text  class="branded-grey"  @click="handleDialogOpen({type:'monitor' , data:scope.row})" tabindex="0">
                    <v-icon small  style="padding-right: 8px;">view_list</v-icon>
                    Monitor
                  </v-btn>
                </div>
                <div class="action-button" v-if="scope.row.list_code != 0 && !scope.row.lmb_id">
                  <v-btn flat text  class="branded-grey"  @click="handleDialogOpen({type:'export', data:{analytics:true, bulb_name:scope.row.name, bulb_id:scope.row.id}})" tabindex="0">
                    <v-icon small  style="padding-right: 8px;">cloud_download</v-icon>
                    Export Analytics
                  </v-btn>
                </div>
                <v-divider></v-divider>
                <div class="action-button-delete" >
                  <v-btn flat text  class="branded-grey"  @click="handleDialogOpen({type:'remove' , data:scope.row})" tabindex="0">
                    <v-icon small style="padding-right: 8px;">delete</v-icon>
                    Remove From Folder
                  </v-btn>
                </div>
              </div>
              <v-btn flat class="no-hover" slot="reference" >
                <v-icon class="hover-white cursor padding branded-text">more_vert</v-icon>
              </v-btn>
            </el-popover>
          </template>
        </el-table-column>
        <template slot="empty">
          <div class="column">
            <span v-if="queryParamsInstructors.search != ''">
              No Data matching search
            </span>
            <span v-if="queryParamsInstructors.search === ''">
              No Data in folder
            </span>
          </div>
        </template>
      </el-table>

      <!--videos table-->
      <el-table
      v-if="activeViewInstructor === 'My-Videos' && dynamicDataLoaded"
      :data="videos.data"
      :cell-class-name="thumbnailColumn"
      :header-cell-class-name="sortClasses"
      @sort-change="sortChange"
      style="width: 100%"
      :max-height="maxHeight"
      >
        <el-table-column
          prop="thumbnail"
          label=""
          align="center"
          width="80">
          <template slot-scope="scope" v-if="popoverReset">
            <el-popover  trigger="click" placement="left" :disabled="instructorAjaxing" width="140">
              <div>
                <div class="action-button">
                  <v-btn flat text  class="branded-grey" @click="handleDialogOpen({type:'preview' , data:scope.row})">
                    <v-icon small  style="padding-right: 8px;">play_circle_outline</v-icon>
                    Preview
                  </v-btn>
                </div>
                <div class="action-button">
                  <v-btn flat text  class="branded-grey" @click="buildVideoBulb(scope.row.video_id)">
                    <v-icon small  style="padding-right: 8px;">lightbulb</v-icon>
                    Build Into Bulb
                  </v-btn>
                </div>
                <div class="action-button">
                  <v-btn flat text  class="branded-grey" @click="handleDialogOpen({type:'confirm' , data:{type:'video', data: scope.row}})">
                    <v-icon small  style="padding-right: 8px;">delete</v-icon>
                    Remove
                  </v-btn>
                </div>
              </div>
              <div slot="reference" class="column" style="height:50px;">
              <v-responsive :aspect-ratio="16/9"  height="36px" width="64px" max-height="36px" max-width="64px">
                <button class="thumbnail-wrapper"><img style="width: 100%; height: 100%" :src="scope.row.thumbnail"/></button>
              </v-responsive>
            </div>
            </el-popover>

          </template>
        </el-table-column>
        <el-table-column
          min-width= "200"
          sortable="custom"
          prop="name"
          label="Video Name">
        </el-table-column>
        <el-table-column
          width="150"
          sortable="custom"
          header-align="center"
          align="center"
          prop="player_duration"
          label="Duration">
        </el-table-column>
        <el-table-column
          header-align="center"
          align="center"
          width="100"
          prop=""
          label="Actions">
          <template slot-scope="scope" v-if="popoverReset">
            <el-popover  trigger="click" placement="left" :disabled="instructorAjaxing" width="140">
              <div>
                <div class="action-button">
                  <v-btn flat text  class="branded-grey" @click="handleDialogOpen({type:'preview' , data:scope.row})">
                    <v-icon small  style="padding-right: 8px;">play_circle_outline</v-icon>
                    Preview
                  </v-btn>
                </div>
                <div class="action-button">
                  <v-btn flat text  class="branded-grey" @click="buildVideoBulb(scope.row.video_id)">
                    <v-icon small  style="padding-right: 8px;">lightbulb</v-icon>
                    Build Into Bulb
                  </v-btn>
                </div>
                <div class="action-button">
                  <v-btn flat text  class="branded-grey" @click="handleDialogOpen({type:'confirm' , data:{type:'video', data: scope.row}})">
                    <v-icon small  style="padding-right: 8px;">remove_circle</v-icon>
                    Remove
                  </v-btn>
                </div>
              </div>
              <v-btn flat class="no-hover" slot="reference" >
                <v-icon class="hover-white cursor padding branded-text">more_vert</v-icon>
              </v-btn>
            </el-popover>
          </template>
        </el-table-column>
        <template slot="empty">
          <span v-if="queryParamsInstructors.search === ''">
            All videos used in bulbs appear here
          </span>
          <span v-if="queryParamsInstructors.search != ''">
            No Videos
          </span>
        </template>
      </el-table>


      <!--classes table-->
      <el-table
      v-if="activeViewInstructor === 'Classes' && dynamicDataLoaded"
      :data="classes.data"
      :cell-class-name="thumbnailColumn"
      :header-cell-class-name="sortClasses"
      @sort-change="sortChange"
      style="width: 100%"
      :max-height="maxHeight"
      >
        <el-table-column
          header-align="center"
          align="center"
          width="50"
          prop=""
          label="">
          <template slot-scope="scope">
            <div class="row-center">
              <div v-if="scope.row.lmsType && scope.row.archived === null">
                <img class="lms-img-small" :src="scope.row.lmsImg" style="margin-top: 8px; margin-right: 8px;">
                <v-icon v-if="!isTeacherSectionArchived(scope.row.teacherSectionArchived)" :color="scope.row.default_color">folder</v-icon>
                <v-icon v-else :color="scope.row.default_color">archive</v-icon>
              </div>
              <v-icon v-else-if="
              !scope.row.lmsType
              && !isSectionArchived(scope.row)"
                :color="scope.row.default_color">
                folder_shared
              </v-icon>
              <v-icon v-else>archive</v-icon>
            </div>
          </template>
        </el-table-column>
        <el-table-column
          header-align="center"
          align="center"
          width="100"
          prop=""
          label="">
          <template slot-scope="scope">
            <Tooltip v-if="scope.row.containerRole === 1" top>
              <v-icon style="opacity: 60%">security</v-icon>
              <template v-slot:text>
                You are the owner of this class.
              </template>
            </Tooltip>
            <Tooltip v-else-if="scope.row.containerRole === 2" top>
              <v-icon style="opacity: 60%">create</v-icon>
              <template v-slot:text>
                You are an Instructor of this class.
              </template>
            </Tooltip>
            <Tooltip v-else top>
              <v-icon style="opacity: 60%">remove_red_eye</v-icon>
              <template v-slot:text>
                You are a Teaching Assistant for this class.
              </template>
            </Tooltip>
          </template>
        </el-table-column>
        <el-table-column
          min-width= "200"
          sortable="custom"
          prop="name"
          label="Class Name">
          <template slot-scope="scope">
            <div class="row-start" style="width: 500px"
            tabIndex="0" :aria-label="`Go to ${scope.row.name}`">
              <Tooltip top>
                <span
                  class="selectable"
                  :class="[ isSafari ? 'safari-bulb-name-truncate' : 'bulb-name-truncate' ]"
                  v-if="
                  (
                    scope.row.archived === null
                    || !isSectionArchived(scope.row)
                  )
                  && !isTeacherSectionArchived(scope.row.teacherSectionArchived)"
                  @click="setNavData(['Bulbs', {section_id:scope.row.id}, scope.row.name])">
                  {{scope.row.name}}
                </span>
                <span
                  v-else
                  :class="[ isSafari ? 'safari-bulb-name-truncate' : 'bulb-name-truncate' ]">
                  {{ scope.row.name }}
                </span>
                <template v-slot:text>
                  {{ scope.row.name }}
                </template>
              </Tooltip>
            </div>
          </template>
        </el-table-column>
        <el-table-column
          :width="classes.archived ? 150 : 1"
          header-align="center"
          align="center"
          sortable="custom"
          prop=""
          v-if="classes.archived"
          label="Archived">
          <template slot-scope="scope">
            <span v-if="isTeacherSectionArchived(scope.row.teacherSectionArchived)">{{scope.row.teacherSectionArchived}}</span>
            <span v-else>{{scope.row.archived ? scope.row.archived : ''}}</span>
          </template>
        </el-table-column>
        <el-table-column
          width="150"
          header-align="center"
          align="center"
          sortable="custom"
          prop="timestamp"
          label="Created">
        </el-table-column>
        <el-table-column
          header-align="center"
          align="center"
          width="100"
          prop=""
          label="Bulbs">
          <template slot-scope="scope">
            <v-icon
              class="hover-white cursor padding branded-text"
              tabIndex="0" aria-label="See bulbs in this class"
              @click="setNavData(['Bulbs', {section_id:scope.row.id}, scope.row.name, null, scope.row.lmsType])"
              :disabled="
              isSectionArchived(scope.row)
              || isTeacherSectionArchived(scope.row.teacherSectionArchived)">
              lightbulb
            </v-icon>
          </template>
        </el-table-column>
        <el-table-column
          header-align="center"
          align="center"
          width="100"
          prop=""
          label="Gradebook">
          <template slot-scope="scope">
            <v-icon
              class="align-center hover-white cursor padding branded-text"
              tabIndex="0"
              aria-label="See the gradebook for this class"
              @click="setNavData(['Gradebook', {section_id:scope.row.id}, scope.row.name , null, scope.row.lmsType])"
              :disabled="
              isSectionArchived(scope.row)
              || isTeacherSectionArchived(scope.row.teacherSectionArchived)">
              view_list
            </v-icon>
          </template>
        </el-table-column>
        <el-table-column
          header-align="center"
          align="center"
          width="100"
          prop=""
          label="Learners">
          <template slot-scope="scope">
            <v-icon
              class="hover-white cursor padding branded-text"
              tabIndex="0"
              aria-label="See the learners in this class"
              @click="setNavData(['Learners', {section_id:scope.row.id}, scope.row.name , null, scope.row.lmsType])"
              :disabled="
              isSectionArchived(scope.row)
              || isTeacherSectionArchived(scope.row.teacherSectionArchived)">
              people
            </v-icon>
          </template>
        </el-table-column>
        <el-table-column
          header-align="center"
          align="center"
          width="100"
          prop=""
          label="Actions">
          <template slot-scope="scope" v-if="popoverReset && (!isSectionArchived(scope.row) || (scope.row.containerRole === 1 && isSectionArchived(scope.row)))">
            <el-popover  trigger="click" placement="left" :disabled="instructorAjaxing" @show="handlePopoverShow">
              <div aria-live="polite">
                <div
                  class="action-button"
                  v-if="(
                    !isSectionArchived(scope.row)
                    && (
                      !scope.row.consumer_key
                      || scope.row.consumer_key === 'clever'
                    )
                  )"
                >
                  <v-btn flat text class="branded-grey class-button"  @click="handleDialogOpen({type:'editMenu' , data:scope.row})" >
                    <v-icon small  style="padding-right: 8px;">edit</v-icon>
                    Edit
                  </v-btn>
                </div>
                <div  class="action-button" v-if="!isSectionArchived(scope.row) && !scope.row.consumer_key && isSchoolUser && isSchoolUser && scope.row.containerRole === 1 && !scope.row.lmb_id">
                  <v-btn
                    @click="instructorData.migrated ? null : handleDialogOpen({type: 'coursePermission' , data: scope.row})"
                    :disabled="!!instructorData.migrated"
                    flat
                    text
                    class="class-button"
                    :class="instructorData.migrated ? null : 'branded-grey'"
                  >
                    <v-icon
                      small
                      class="pr-2"
                    >
                      group_add
                    </v-icon>
                    Collaborate
                  </v-btn>
                </div>
                <div class="action-button" v-if="!isSectionArchived(scope.row) && scope.row.containerRole === 1">
                  <v-btn flat text  class="branded-grey class-button"   @click="handleDialogOpen({type:'remove' , data:scope.row})">
                    <v-icon small  style="padding-right: 8px;">archive</v-icon>
                    Archive
                  </v-btn>
                </div>
                <div class="action-button" v-if="!isSectionArchived(scope.row) && scope.row.containerRole !== 1 && !isTeacherSectionArchived(scope.row.teacherSectionArchived)">
                  <v-btn flat text  class="branded-grey class-button"   @click="setDashModal({ type: 'removeAccess', class: scope.row })">
                    <v-icon small  style="padding-right: 8px;">person_add_disabled</v-icon>
                    Leave Class
                  </v-btn>
                </div>
                <div class="action-button" v-if="!isSectionArchived(scope.row) && scope.row.containerRole !== 1 && isTeacherSectionArchived(scope.row.teacherSectionArchived)">
                  <v-btn flat text  class="branded-grey class-button"   @click="setDashModal({ type: 'rejoinClass', class: scope.row})">
                    <v-icon small  style="padding-right: 8px;">person_add</v-icon>
                    Rejoin Class
                  </v-btn>
                </div>
                <div class="action-button" v-if="isSectionArchived(scope.row) && scope.row.containerRole === 1">
                  <v-btn flat text  class="branded-grey class-button"   @click="handleDialogOpen({type:'confirm', data:{type:'unarchive', data:scope.row}})">
                    <v-icon small  style="padding-right: 8px;">unarchive</v-icon>
                    Unarchive
                  </v-btn>
                </div>
              </div>
              <v-btn flat class="no-hover" slot="reference" >
                <v-icon class="hover-white cursor padding branded-text">more_vert</v-icon>
              </v-btn>
            </el-popover>
          </template>
        </el-table-column>
        <template slot="empty">
          <span class="branded-text cursor" @click="handleDialogOpen({type:'addMenu', data:{}})" v-if="queryParamsInstructors.search === ''" >
            Create your first class
          </span>
          <span v-if="queryParamsInstructors.search != ''">
            No Classes
          </span>
        </template>
      </el-table>

      <!-- My Classes => Click Bulb => Bulb Tab --> 
      <el-table
      v-if="activeViewInstructor === 'Bulbs' && dynamicDataLoaded"
      :data="bulbs.data"
      :cell-class-name="thumbnailColumn"
      :header-cell-class-name="sortClasses"
      @sort-change="sortChange"
      style="width: 100%"
      :max-height="maxHeight"
      @selection-change="selectionChange"
      >
        <el-table-column
          type="selection"
          width="55"
          align="center"
          v-if="isSchoolUser && !passbackLinking"
          :selectable="canSelectRow">
        </el-table-column>
        <el-table-column
          prop="thumbnail"
          label=""
          align="center"
          width="80">
          <template slot-scope="scope" v-if="popoverReset">
            <el-popover
              trigger="click"
              placement="left"
              :disabled="instructorAjaxing"
              width="100px"
              @show="handlePopoverShow">
              <div aria-live="polite">
                <div v-if="[1, 2].includes(scope.row.bulb_role)" class="action-button">
                  <v-btn
                    @click="instructorData.migrated ? null : handleEditClick(scope.row)"
                    :disabled="!!instructorData.migrated"
                    flat
                    text
                    :class="instructorData.migrated ? null : 'branded-grey'"
                    tabindex="0"
                  >
                    <v-icon
                      small
                      class="pr-2"
                    >
                      edit
                    </v-icon>
                    Edit Bulb
                  </v-btn>
                </div>
                <div  class="action-button" v-if="school && school.id && !scope.row.lmb_id">
                  <v-btn
                    @click="instructorData.migrated ? null : handleDialogOpen({type: 'shareMenu' , data: scope.row})"
                    :disabled="!!instructorData.migrated"
                    flat
                    text
                    :class="instructorData.migrated ? null : 'branded-grey'"
                  >
                    <v-icon
                      small
                      class="pr-2"
                    >
                      assignment
                    </v-icon>
                    Collaborate
                  </v-btn>
                </div>
                <div class="action-button" v-if="!queryParamsInstructors.lms_class && ([1, 2].includes(selectedClassRole) || scope.row.bulb_role === 1)">
                  <v-btn
                    @click="instructorData.migrated ? null : handleDialogOpen({type: 'assignMenu' , data: scope.row})"
                    :disabled="!!instructorData.migrated"
                    flat
                    text
                    :class="instructorData.migrated ? null : 'branded-grey'"
                  >
                    <v-icon
                      small
                      class="pr-2"
                    >
                      date_range
                    </v-icon>
                    Modify Due Date
                  </v-btn>
                </div>
                <div class="d-flex justify-center align-center" style="height: 35px;">
                  <div  class="action-button">
                    <v-btn flat text class="branded-grey" @click="interactionByBulbNav({label:scope.row.name, property:scope.row.id, data:scope.row})" >
                      <v-icon small  style="padding-right: 8px;">view_list</v-icon>
                      Monitor
                    </v-btn>
                  </div>
                  <v-btn
                    flat icon
                    @click="externalMonitorHotlink(scope.row)"
                  >
                    <v-icon
                      small
                      color="primary"
                    >
                      open_in_new
                    </v-icon>
                  </v-btn>
                </div>
                
                <div class="action-button" v-if="scope.row.list_code != 0 && !scope.row.lmb_id">
                  <v-btn flat text class="branded-grey" @click="playAuth(scope.row)" tabindex="0">
                    <v-icon small  style="padding-right: 8px;">play_circle_outline</v-icon>
                    Preview
                  </v-btn>
                </div>
                <div  v-if="[1, 2].includes(scope.row.bulb_role) && !queryParamsInstructors.lms_class" class="action-button">
                  <v-btn flat text class="branded-grey" @click="handleDialogOpen({type:'remove' , data:scope.row})">
                    <v-icon small  style="padding-right: 8px;">remove_circle</v-icon>
                    Remove
                  </v-btn>
                </div>
              </div>
              <div slot="reference" >
                <div class="column" style="height:50px;">
                  <v-responsive aria-label="bulb thumbnail" :aspect-ratio="16/9"  height="36px" width="64px" max-height="36px" max-width="64px">
                    <button class="thumbnail-wrapper"><img style="width: 100%; height: 100%" :src="scope.row.thumbnail"/></button>
                  </v-responsive>
                </div>
              </div>
            </el-popover>
          </template>
        </el-table-column>
        <el-table-column
        align="center"
        width="50"
        v-if="isSchoolUser"
        >
          <template slot-scope="scope">
            <Tooltip v-if="scope.row.bulb_role === 2" top>
              <v-icon>create</v-icon>
              <template v-slot:text>
                You are a Co-Owner of this bulb.
              </template>
            </Tooltip>
            <Tooltip v-else-if="scope.row.bulb_role === 3" top>
              <v-icon>remove_red_eye</v-icon>
              <template v-slot:text>
                You are a Facilitator of this bulb.
              </template>
            </Tooltip>
          </template>
        </el-table-column>
        <el-table-column
          min-width= "200"
          sortable="custom"
          prop="name"
          label="Bulb Name">
          <template slot-scope="scope">
            <Tooltip top>
              <span
                :class="[ isSafari ? 'safari-bulb-name-truncate' : 'bulb-name-truncate' ]">
                {{ scope.row.name }}
              </span>
              <template v-slot:text>
                {{ scope.row.name }}
              </template>
            </Tooltip>
          </template>
        </el-table-column>
        <el-table-column
          width="150"
          prop="responses"
          header-align="center"
          align="center"
          label="Responses">
        </el-table-column>
        <el-table-column
          v-if="!queryParamsInstructors.lms_class"
          min-width= "250"
          sortable="custom"
          header-align="center"
          align="center"
          prop="assigned_date"
          label="">
          <template slot="header">
            <span>Assigned Date ({{instructorData.timezoneAbr}})</span>
          </template>
        </el-table-column>
        <el-table-column
          header-align="center"
          align="center"
          width="100"
          prop=""
          label="Actions">
          <template slot-scope="scope" v-if="popoverReset">
            <el-popover
              trigger="click"
              placement="left"
              :disabled="instructorAjaxing"
              width="100px"
              @show="handlePopoverShow">
              <div aria-live="polite">
                <div v-if="[1, 2].includes(scope.row.bulb_role)" class="action-button">
                  <v-btn
                    @click="instructorData.migrated ? null : handleEditClick(scope.row)"
                    :disabled="!!instructorData.migrated"
                    flat
                    text
                    :class="instructorData.migrated ? null : 'branded-grey'"
                    tabindex="0"
                  >
                    <v-icon
                      small
                      class="pr-2"
                    >
                      edit
                    </v-icon>
                    Edit Bulb
                  </v-btn>
                </div>
                <div  class="action-button" v-if="school && school.id && !scope.row.lmb_id">
                  <v-btn
                    @click="instructorData.migrated ? null : handleDialogOpen({type: 'shareMenu' , data: scope.row})"
                    :disabled="!!instructorData.migrated"
                    flat
                    text
                    :class="instructorData.migrated ? null : 'branded-grey'"
                  >
                    <v-icon
                      small
                      class="pr-2"
                    >
                      assignment
                    </v-icon>
                    Collaborate
                  </v-btn>
                </div>
                <div class="action-button" v-if="!queryParamsInstructors.lms_class && ([1, 2].includes(selectedClassRole) || scope.row.bulb_role === 1)">
                  <v-btn
                    @click="instructorData.migrated ? null : handleDialogOpen({type: 'assignMenu' , data: scope.row})"
                    :disabled="!!instructorData.migrated"
                    flat
                    text
                    :class="instructorData.migrated ? null : 'branded-grey'"
                  >
                    <v-icon
                      small
                      class="pr-2"
                    >
                      date_range
                    </v-icon>
                    Modify Due Date
                  </v-btn>
                </div>
                <div class="d-flex justify-center align-center" style="height: 35px;">
                  <div  class="action-button">
                    <v-btn flat text class="branded-grey" @click="interactionByBulbNav({label:scope.row.name, property:scope.row.id, data:scope.row})" >
                      <v-icon small  style="padding-right: 8px;">view_list</v-icon>
                      Monitor
                    </v-btn>
                  </div>
                  <v-btn
                    flat icon
                    @click="externalMonitorHotlink(scope.row)"
                  >
                    <v-icon
                      small
                      color="primary"
                    >
                      open_in_new
                    </v-icon>
                  </v-btn>
                </div>
                <div class="action-button" v-if="scope.row.list_code != 0 && !scope.row.lmb_id">
                  <v-btn flat text  class="branded-grey"  @click="playAuth(scope.row)" tabindex="0">
                    <v-icon small  style="padding-right: 8px;">play_circle_outline</v-icon>
                    Preview
                  </v-btn>
                </div>
                <div v-if="[1, 2].includes(scope.row.bulb_role) && !queryParamsInstructors.lms_class" class="action-button">
                  <v-btn flat text class="branded-grey"  @click="handleDialogOpen({type:'remove' , data:scope.row})">
                    <v-icon small  style="padding-right: 8px;">remove_circle</v-icon>
                    Remove
                  </v-btn>
                </div>
              </div>
              <v-btn flat class="no-hover" slot="reference" >
                <v-icon class="hover-white cursor padding branded-text">more_vert</v-icon>
              </v-btn>
            </el-popover>
          </template>
        </el-table-column>
        <template slot="empty">
          <div class="column">
            <!--<span v-if="queryParamsInstructors.search === '' && legacy.legacy && activeViewInstructor ==='Bulbs'" class="selectable branded-text" @click="handleDialogOpen({type:'confirm', data:{type:'bulbs'}})" style="text-decoration:none; margin: 12px 0px;">-->
            <!--  Missing bulbs in "{{breadcrumbs[1].text}}"? Switch to Classic View.-->
            <!--</span>-->
            <span v-if="LTIlaunch"  style="text-decoration:none; margin: 12px 0px;">
              No Bulbs Assigned in 3.0
            </span>
            <span v-if="queryParamsInstructors.search === '' && !legacy.legacy"  style="text-decoration:none; margin: 12px 0px;">
              No Bulbs Assigned
            </span>
            <span v-if="queryParamsInstructors.search != ''">
              No Bulbs Found
            </span>
          </div>
        </template>
      </el-table>

      <!--bulb attempt table-->
      <el-table
      v-if="activeViewInstructor === 'Bulb-Attempts' && dynamicDataLoaded"
      :data="studentbulbattempts.data"
      :header-cell-class-name="sortClasses"
      @sort-change="sortChange"
      style="width: 100%"
      :max-height="maxHeight"
      >
        <el-table-column
          sortable="custom"
          min-width= "200"
          prop="name"
          label="Student Name">
        </el-table-column>
        <el-table-column
          width="150"
          header-align="center"
          align="center"
          prop="points_available"
          label="Points Available">
        </el-table-column>
        <el-table-column
          width="150"
          sortable="custom"
          header-align="center"
          align="center"
          prop="points_earned"
          label="Points Earned">
        </el-table-column>
        <el-table-column
          width="150"
          sortable="custom"
          header-align="center"
          align="center"
          prop="score"
          label="Final Score">
        </el-table-column>
        <el-table-column
          width="200"
          sortable="custom"
          header-align="center"
          align="center"
          prop="engaged_minutes"
          label="Engaged Minutes">
        </el-table-column>
        <el-table-column
          width="200"
          header-align="center"
          align="center"
          sortable="custom"
          prop="timestamp"
          label="Attempted">
        </el-table-column>
        <template slot="empty">
          <h1>No Data</h1>
        </template>
      </el-table>

      <!--gradebook table (No longer includes playlist table)-->
      <el-table
      v-if="activeViewInstructor === 'Gradebook' && dynamicDataLoaded && !isPlaylistGradebook"
      :data="gradebook.data"
      style="width: 100%"
      :max-height="maxHeight"
      :header-cell-class-name="gradebookSortClasses"
      :cell-class-name="columnClass"
      @sort-change="sortChange"
      @selection-change="selectionChange"
      @header-click="interactionByBulbNav"
      :key="gradebookTableKey"
      >
        <el-table-column
          v-if="hasInstructorLearnerSchoolInGradebook"
          sortable="custom"
          prop="institution"
          label="Instructor School"
          min-width="190">
        </el-table-column>
        <el-table-column
          fixed
          sortable="custom"
          prop="student_name"
          label="Learner Name"
          min-width="150">
          <template slot-scope="scope" v-if="popoverReset">
             <el-popover
              trigger="click"
              placement="bottom-start"
              :disabled="instructorAjaxing || embedded"
              width="200"
              @show="handlePopoverShow">
              <div>
                <div  class="action-button">
                  <v-btn
                    flat
                    text
                    class="branded-grey"
                    @click="studentByBulbNav(scope.row)">
                    <v-icon small style="padding-right: 8px;">streetview</v-icon>
                    View Learner Attempt
                  </v-btn>
                </div>
              </div>
              <div slot="reference" class="cursor">
                <span class="selectable">{{scope.row.student_name}}</span>
              </div>
            </el-popover>
          </template>
        </el-table-column>
        <el-table-column
          v-for="bulb in gradebook.headers"
          :prop="bulb.id"
          :label="bulb.name"
          min-width="200"
          align="center"
          :key="bulb.id">
          <template slot="header" slot-scope="scope">
            <div class="gradebook-header">
              <p class="selectable gradebook-name text-truncate">{{bulb.name}}</p>
              <p v-if="!queryParamsInstructors.lms_class" class="gradebook-date">{{gradebookDate(bulb.assigned_date)}}</p>
              <p class="gradebook-date">{{averageBulbScore(bulb.averageScore, 'bulb')}}</p>
            </div>
          </template>
          <template slot-scope="scope">
            <el-popover trigger="click" placement="top"  width="400" :disabled="!scope.row[bulb.id]">
                <div class="question_header">
                  <v-responsive :aspect-ratio="16/9" max-height="36px" max-width="64px">
                    <button class="thumbnail-wrapper"><img style="width: 100%; height: 100%" :src="scope.row.thumbnail"/></button>
                  </v-responsive>
                  <span>{{bulb.name}}</span>
                </div>
                <div class="question-popover">
                  <div class="question-format">
                    <ul>
                      <li><span class="bold" style="margin-right:3px;">Score:</span> {{scope.row[bulb.id] ? scope.row[bulb.id].score : '-'}}</li>
                      <li><span class="bold" style="margin-right:3px;">Points:</span> {{scope.row[bulb.id] ? scope.row[bulb.id].points : '-'}}</li>
                      <li><span class="bold" style="margin-right:3px;">Time Spent (min):</span> {{scope.row[bulb.id] ? scope.row[bulb.id].engaged_minutes : '-'}}</li>
                      <li><span class="bold" style="margin-right:3px;">Attempted:</span> {{scope.row[bulb.id] ? scope.row[bulb.id].attempted : '-'}}</li>
                    </ul>
                  </div>
                </div>
                <v-divider></v-divider>
                <div class="question_footer_gradebook">
                  <v-btn class="branded-background text-white" @click="interactionHotlink({property:bulb.id, label: bulb.name})" aria-live="assertive">View Interactions</v-btn>
                </div>
                <div slot="reference" :class="scope.row[bulb.id] ? 'cursor' : ''">
                  <v-btn
                    flat
                    background-color="grey"
                    aria-label="See more information about this attempt"
                    v-if="scope.row[bulb.id]"
                    class="gradebook-tag el-tag el-tag--info">
                    {{bulbScore(scope.row[bulb.id])}}
                    <span
                      v-if="scope.row[bulb.id].archivedAttempt"
                      style="font-size: 17px">
                      *
                    </span>
                  </v-btn>
                  <span v-if="!scope.row[bulb.id]" class="gradebook-tag el-tag el-tag--clear">-</span>
                </div>
              </el-popover>
          </template>
        </el-table-column>
        <template slot="empty">
          <h1>No Data</h1>
        </template>
      </el-table>

      <!-- playlist gradebook table -->
      <InteractionResults
        :event="playlistGradebookMenu.event"
        :item="playlistGradebookMenu.item"
        :attempt="playlistGradebookMenu.attempt"
        :click-function="interactionHotlink"
      />
      <el-table
      v-if="activeViewInstructor === 'Gradebook' && dynamicDataLoaded && isPlaylistGradebook"
      :data="gradebook.data"
      style="width: 100%"
      :max-height="maxHeight"
      :header-cell-class-name="gradebookSortClasses"
      :cell-class-name="columnClass"
      @sort-change="sortChange"
      @header-click="interactionByBulbNav"
      @selection-change="selectionChange"
      >
        <el-table-column
          type="selection"
          width="55"
          align="center"
          v-if="isSchoolUser"
          :selectable="playlistHasAttempts" 
        />
        <el-table-column
          sortable="custom"
          fixed
          prop="student_name"
          label="Learner Name"
          min-width="150" 
        >
          <template slot-scope="scope" v-if="popoverReset">
            <el-popover
              trigger="click"
              placement="bottom-start"
              :disabled="instructorAjaxing || embedded"
              width="220"
              @show="handlePopoverShow"
              >
              <div>
                <div  class="action-button">
                  <v-btn
                    flat
                    text
                    class="branded-grey"
                    @click="studentByBulbNav(scope.row)"
                    >
                    <v-icon small style="padding-right: 8px">streetview</v-icon>
                    View Learner's Bulb Attempts
                  </v-btn>
                </div>
                <div class="action-button">
                  <v-btn
                    flat
                    text
                    class="branded-grey"
                    @click="launchStudentCertificate(scope.row.id)"
                    v-if="scope.row.playlistAttemptComplete === 1"
                    >
                    <v-icon small style="padding-right: 8px;">card_membership</v-icon>
                    Print Learner Certificate
                  </v-btn>
                </div>
                <div class="action-button">
                  <v-btn
                    @click="instructorData.migrated ? null : setDashModal({ type: 'confirmResetPlaylistAttempt', playlist: playlistSelected, learner: scope.row.id })"
                    v-if="!_.isNull(scope.row.playlistAttemptComplete)"
                    flat
                    text
                    :disabled="!!instructorData.migrated"
                    :class="instructorData.migrated ? null : 'branded-grey'"
                  >
                    <v-icon small style="padding-right: 8px;">redo</v-icon>
                    Reset Attempt
                  </v-btn>
                </div>
              </div>
              <div slot="reference" class="cursor">
                <span class="selectable">{{scope.row.student_name}}</span>
              </div>
            </el-popover>
          </template>
        </el-table-column>
        <el-table-column
          prop="overallScore"
          label="Playlist Score"
          align="center"
          min-width="225" 
        >
          <template slot="header">
            <div class="gradebook-header">
              <p class="gradebook-name text-truncate">Playlist Score</p>
              <p v-if="gradebook.headers[0].averagePlaylistScore" class="gradebook-date" >Average score: {{gradebook.headers[0].averagePlaylistScore}}%</p>
            </div>
          </template>
          <template slot-scope="scope">
            <div class="column">
              <el-tag v-if="scope.row.overallScore !== '-'" type="info">{{scope.row.overallScore}}</el-tag>
              <div v-else>-</div>
            </div>
          </template> 
        </el-table-column>
        <el-table-column
          prop="totalTimeSpent"
          label="Time Spent (hh:mm:ss)"
          align="center"
          min-width="170" 
        >
          <template slot-scope="scope">
            <div class="column">
              <el-tag v-if="scope.row.totalTimeSpent !== '-'" type="info">{{scope.row.totalTimeSpent}}</el-tag>
              <div v-else>-</div>
            </div>
          </template> 
        </el-table-column>
        <el-table-column
          prop="playlistAttemptComplete"
          label="Status"
          align="center"
          min-width="150"
        >
          <template slot-scope="scope">
            <div class="column">
              <el-tag v-if="!_.isNull(scope.row.playlistAttemptComplete) && scope.row.playlistAttemptComplete === 0" type="warning">In Progress</el-tag>
              <el-tag v-else-if="scope.row.playlistAttemptComplete === 1" type="success">Completed</el-tag>
              <el-tag v-else type="danger">Not Started</el-tag>
            </div>
          </template> 
        </el-table-column>
        <el-table-column
          v-for="item in gradebook.headers"
          :prop="item.p_item_id"
          :label="item.p_item_name"
          min-width="200"
          align="center"
          :key="item.p_item_id"
        >
          <template slot="header">
            <div class="gradebook-header">
              <p v-if="item.p_item_type === 'bulb'" class='selectable gradebook-name text-truncate'>
              {{item.b_name}}
              </p>
              <p v-if="item.p_item_type !== 'bulb'" class="gradebook-name text-truncate">
              {{item.p_item_name}}
              </p>
              <p v-if="item.p_item_type === 'bulb' && item.bulbAverageForPlaylist" class="gradebook-date">{{averageBulbScore(item.bulbAverageForPlaylist, 'playlist')}}</p>
            </div>
          </template>
          <template slot-scope="scope">
            <div v-for="attempt in scope.row.attempts" :key="attempt.module_item_attempt_id">
              <v-btn
                @click="initPlaylistGradebookMenu($event, item, attempt)"
                v-if="attempt.mi_type === 'bulb' && attempt.moduleItemId == item.p_item_id && !_.isNull(attempt.ba_points)"
                flat
                background-color="grey"
                class="gradebook-tag el-tag el-tag--info"
                >
                {{bulbScore(attempt)}}
              </v-btn>
              <span v-if="attempt.mi_type === 'bulb' && attempt.moduleItemId == item.p_item_id && _.isNull(attempt.ba_points)">-</span>

              <div v-if="attempt.moduleItemId == item.p_item_id && attempt.mi_type !== 'bulb'">
                <span v-if="_.isNull(attempt.module_item_attempt_complete) || !attempt.module_item_attempt_complete" type="info">-</span>
                <el-tag v-if="!_.isNull(attempt.module_item_attempt_complete) && attempt.module_item_attempt_complete === 0" type="info">In Progress</el-tag>
                <el-tag v-if="attempt.module_item_attempt_complete === 1" type="info">Completed</el-tag>
              </div>
            </div>
            <span v-if="scope.row.attempts.length === 0 || moduleItemsNotAttempted(gradebook.headers, scope.row.attempts).includes(item) ">-</span>
          </template>
        </el-table-column>
      </el-table>

      <!--students table-->
      <el-table
      v-if="activeViewInstructor === 'Learners' && dynamicDataLoaded"
      ref="studentClassTable"
      :data="students.data"
      :header-cell-class-name="sortClasses"
      @sort-change="sortChange"
      @selection-change="selectionChange"
      style="width: 100%"
      :max-height="maxHeight"
      >
        <el-table-column
          v-if="queryParamsInstructors.section_id !=''"
          type="selection"
          width="55"
          >
        </el-table-column>
        <el-table-column
          sortable="custom"
          prop="student_name"
          label="Learner Name"
          min-width="200">
        </el-table-column>
        <el-table-column
          sortable="custom"
          header-align="center"
          align="center"
          prop="email"
          label="Email"
          min-width="200">
        </el-table-column>
        <el-table-column
          min-width="170"
          header-align="center"
          align="center"
          prop="bulb_attempts"
          label="Bulb Attempts">
        </el-table-column>
        <el-table-column
          min-width="170"
          header-align="center"
          align="center"
          prop="engagement_hours"
          label="Time Spent (hours)">
        </el-table-column>
        <el-table-column
          min-width="200"
          header-align="center"
          align="center"
          prop="secondary_password"
          label="Secondary Password">
        </el-table-column>
        <template slot="empty">
          <h1>No Data</h1>
        </template>
      </el-table>


      <!--interactions table-->
      <el-table
      v-if="activeViewInstructor === 'Interactions' && dynamicDataLoaded"
      :data="interactions.data"
      :header-cell-class-name="sortClasses"
      style="width: 100%"
      :max-height="maxHeight"
      @selection-change="selectionChange"
      @sort-change="sortChange"
      >
        <el-table-column
          type="selection"
          width="55">
        </el-table-column>
        <el-table-column
          fixed
          sortable="custom"
          prop="student_name"
          label="Learner Name"
          min-width="200">
          <template slot-scope="scope" v-if="popoverReset">
             <el-popover
              trigger="click"
              placement="bottom-start"
              :disabled="instructorAjaxing || embedded"
              width="200"
              @show="handlePopoverShow">
              <div>
                <div  class="action-button">
                  <v-btn flat text class="branded-grey"  @click="gradeStudent(scope.row)">
                    <v-icon small style="padding-right: 8px;">streetview</v-icon>
                    View Learner Attempt
                  </v-btn>
                </div>
                <div class="action-button" v-if="school && school.id">
                  <v-btn flat text class="branded-grey"  @click="exportLearnerAttempt(scope.row.id)" :disabled="!scope.row.bulbattempt_id">
                    <v-icon small style="padding-right: 8px;">description</v-icon>
                    Export Learner Attempt
                  </v-btn>
                </div>
                <div class="action-button">
                  <v-btn
                    @click="instructorData.migrated ? null : resetStudentBulbAttempt(scope.row)"
                    :disabled="!!instructorData.migrated"
                    flat
                    text
                    :class="instructorData.migrated ? null : 'branded-grey'"
                  >
                    <v-icon
                      small
                      class="pr-2"
                    >
                      redo
                    </v-icon>
                    Reset Attempt
                  </v-btn>
                </div>
              </div>
              <div slot="reference" class="cursor">
                <v-btn flat text class="selectable">{{scope.row.student_name}}</v-btn>
              </div>
            </el-popover>
          </template>
        </el-table-column>
        <el-table-column
          header-align="center"
          align="center"
          min-width= "120"
          prop="score"
          label="Score">
          <template slot-scope="scope">
            <span>{{scope.row.score}}</span>
            <span v-if="scope.row.archivedAttempt" style="font-size:20px;">*</span>
          </template>
        </el-table-column>
        <el-table-column
          width= "180"
          header-align="center"
          prop="status"
          label="Status">
          <template slot-scope="scope" >
            <div class="column">
              <el-tag v-if="!scope.row.complete && scope.row.complete != 0" type="danger" class="mt-2">{{scope.row.status}}</el-tag>
              <el-tag v-if="scope.row.complete === 0" type="warning" class="mt-2">{{scope.row.status}}</el-tag>
              <el-tag v-if="scope.row.complete === 1" type="success" class="mt-2">{{scope.row.status}}</el-tag>
            </div>
          </template>
        </el-table-column>
        <el-table-column
          v-for="question in interactions.headers"
          :prop="question.interaction_id"
          :label="question.interaction_type"
          width="150"
          align="center"
          :key="question.interaction_id"
          :label-class-name="[
            question.bank_type === 'random' ? 'question-bank-box' : '',
            (
              question.bank_type === 'random'
              && question.order === 0
            ) ? 'first-bank-box' : '',
            (
              question.bank_type === 'random'
              && question.order + 1 === question.bank_interaction_count
            ) ? 'last-bank-box' : ''
          ].join(' ')"
        >
          <template slot="header" slot-scope="scope" v-if="popoverReset">
            <div class="question-header" aria-label="Interaction table header">
              <el-popover
                class="grade-drop-down"
                trigger="click"
                :disabled="embedded"
                placement="bottom"
                width="170"
                @show="handlePopoverShow">
                <div aria-live="polite">
                  <div class="action-button">
                    <v-btn
                      flat
                      text
                      class="branded-grey"
                      @click="gradeInteraction({property: question.interaction_id, property_type: question.interaction_type})">
                      <v-icon small style="padding-right: 8px;">rate_review</v-icon>
                      Grade All
                    </v-btn>
                  </div>
                  <div class="action-button">
                    <v-btn flat text  class="branded-grey" @click="openInteractionModal(question)">
                      <v-icon small style="padding-right: 8px;">insert_chart</v-icon>
                      Interaction Data
                    </v-btn>
                  </div>
                </div>
                <div slot="reference" class="interaction-header">
                  <button aria-label="Interaction action menu. Click space to open menu." class="interaction-question-icon cursor">
                    <v-icon>{{interactionIconMap[question.interaction_type]}}</v-icon>
                    <h5 class="cursor question-timestamp" aria-hidden="true">{{question.display_in_time}}</h5>
                  </button>
                </div>
              </el-popover>
            </div>
          </template>
          <template slot-scope="scope" v-if="popoverReset">
            <el-popover trigger="click" placement="left"  width="500" :disabled="!scope.row[question.interaction_id]" @show="toggleOnViewer(scope.row[question.interaction_id].interaction_attempt_id)">
              <div :class="question.interaction_type === 'free_response' ? 'popover-scroll' : ''">
                <div class="question_header">
                  <v-icon color="white">{{interactionIconMap[question.interaction_type]}}</v-icon>
                  <span>Points: {{scope.row[question.interaction_id] ? (scope.row[question.interaction_id].points_earned || '-') : '-'}}  / {{scope.row[question.interaction_id] ? scope.row[question.interaction_id].points_available : '-'}}</span>
                  <span v-if="question.interaction_type != 'discussion_q'">Engagement (sec): {{scope.row[question.interaction_id] ? scope.row[question.interaction_id].time_elapsed : '-'}}</span>
                </div>
                <div
                  v-if="scope.row[question.interaction_id]"
                  class="question-popover"
                >
                  <div style="height:350px; width: 100%;" aria-live="polite">
                    <PlaypositInteraction
                      v-if="interactionAttemptShow === `Interactions-${scope.row[question.interaction_id].interaction_attempt_id}`"
                      :bulb-id="parseInt(queryParamsInstructors.bulb_id, 10)"
                      :section-id="parseInt(queryParamsInstructors.section_id, 10)"
                      :student-id="parseInt(scope.row.id, 10)"
                      :teacher-id="instructorData.id"
                      :interactionId="parseInt(question.interaction_id, 10)"
                      :token="instructorData.token"
                      :setViewedComments="setViewedComments"
                      :restrict-discussion-comments-by-student-id="scope.row.id"
                      topper="review"
                      user-type="teacher"
                      discussion-role="observer"
                      perspective="answered"
                    />
                  </div>
                </div>
                <v-divider></v-divider>
                <div>
                  <InstructorQuestionFooter
                    :bulbId="parseInt(queryParamsInstructors.bulb_id, 10)"
                    :sectionId="queryParamsInstructors.section_id"
                    :instructorData="instructorData"
                    :interactionData="scope.row[question.interaction_id]"
                    :interactionAttemptShow="interactionAttemptShow"
                    :interactionType="question.interaction_type"
                    :saveGrade="saveGrade"
                    :footerKey="footerCounter"
                  />
                </div>
              </div>
              <div slot="reference" :class="scope.row[question.interaction_id] ? 'cursor popup' : ''" aria-label="Interaction response">
                <div v-if="scope.row[question.interaction_id]" class="mt-2">
                  <GradeCell
                    user-type="teacher"
                    :question="question"
                    :data="scope.row[question.interaction_id]"
                    :view="activeViewInstructor"
                    :show-points-badges="(
                      filtersInteraction
                      && filtersInteraction.isFiltered
                      && filtersInteraction.showPointsBadges
                    )"
                  ></GradeCell>
                </div>
                <div
                  v-else
                    v-dompurify-html="`<span>${scope.row.bulbattempt_id && interactions.answeredBankIds.includes(question.bank_id) ? 'N/A' : '-'}</span>`"
                ></div>
              </div>
              </el-popover>
          </template>
        </el-table-column>
        <template slot="empty">
          <h1>No Data</h1>
        </template>
      </el-table>

      <!--learner made bulb table-->
      <el-table
      v-if="activeViewInstructor === 'Learner-Made-Bulb' && dynamicDataLoaded"
      :data="lmb.data"
      :header-cell-class-name="sortClasses"
      style="width: 100%"
      :max-height="maxHeight"
      @header-click="singleInteractionNav"
      @selection-change="selectionChange"
      @sort-change="sortChange"
      >
        <el-table-column
          type="selection"
          width="55">
        </el-table-column>
        <el-table-column
          fixed
          sortable="custom"
          prop="student_name"
          label="Learner Name"
          min-width="200">
        </el-table-column>
        <el-table-column
          width= "270"
          header-align="center"
          prop="status"
          label="Status">
          <template slot-scope="scope" >
            <div class="column">
              <el-tag v-if="!scope.row.complete && scope.row.complete != 0" type="danger">{{scope.row.status}}</el-tag>
              <el-tag v-if="scope.row.complete === 0" type="warning">{{scope.row.status}}</el-tag>
              <el-tag v-if="scope.row.complete === 1" type="success" class="cursor">{{scope.row.status}}</el-tag>
            </div>
          </template>
        </el-table-column>
        <el-table-column
          header-align="center"
          align="center"
          :width="editGrades? 325 : 150"
          prop="score"
          label="Score">
          <template slot-scope="scope">
            <template v-if="(
              editGrades
              && scope.row.points_available
            )">
              <el-radio-group
                v-if="scope.row.points_available <= 10"
                v-model="scope.row.points_earned"
                @change="saveLMBGrade({bulb_attempt: scope.row.bulbattempt_id, points_earned: scope.row.points_earned})"
              >
                <el-radio-button
                  :label="scope.row.points_available - scope.row.points_available"
                >
                  0
                </el-radio-button>
                <el-radio-button
                  v-for="i in scope.row.points_available"
                  :label="i"
                  :key="i"
                >
                  {{i}}
                </el-radio-button>
              </el-radio-group>
              <div
                v-else
                class="center"
              >
                <v-text-field
                  @input="debouncedSaveLMBGrade({
                    bulb_attempt: scope.row.bulbattempt_id,
                    points_earned: scope.row.points_earned,
                    points_available: scope.row.points_available,
                    row: scope.row,
                  })"
                  class="grade-number-input"
                  :min="0"
                  :max="scope.row.points_available"
                  type="number"
                  v-model.number="scope.row.points_earned"
                >
                  <template v-slot:append>
                    <span class="caption grey--text">
                      out of {{scope.row.points_available}}
                    </span>  
                  </template>
                </v-text-field>
              </div>
            </template>
            <span v-if="!editGrades">{{scope.row.score}}</span>
          </template>
        </el-table-column>
        <el-table-column
          header-align="center"
          align="center"
          width="100"
          prop=""
          label="">
          <template slot-scope="scope">
            <Tooltip top>
              <v-btn icon flat class="branded-text" @click="handleDialogOpen({type:'confirm', data:{type:'unlocklmb', data:scope.row}})" v-if="scope.row.complete === 1">
                <v-icon tabIndex="0"
                aria-label="Allow learner to edit" class="branded-text" >lock_open</v-icon>
              </v-btn>
              <template v-slot:text>
                Allow Learner to Edit
              </template>
            </Tooltip>
          </template>
        </el-table-column>
        <el-table-column
          header-align="center"
          align="center"
          width="100"
          prop=""
          label="Preview">
          <template slot-scope="scope">
            <v-btn icon flat class="branded-text" @click="playLMB({id:scope.row.lmb_bulb_id, section_id: scope.row.lmb_section_id})" :disabled="!scope.row.complete && (scope.row.complete != 0)">
              <v-icon tabIndex="0" aria-label="Preview the bulb" class="branded-text" >play_circle_outline</v-icon>
            </v-btn>
          </template>
        </el-table-column>
        <!--<el-table-column-->
        <!--  header-align="center"-->
        <!--  align="center"-->
        <!--  width="100"-->
        <!--  prop=""-->
        <!--  label="Edit">-->
        <!--  <template slot-scope="scope">-->
        <!--    <v-btn icon flat class="branded-text" @click="edit(scope.row.lmb_bulb_id)" :disabled="!scope.row.lmb_bulb_id">-->
        <!--      <v-icon class="branded-text" >edit</v-icon>-->
        <!--    </v-btn>-->
        <!--  </template>-->
        <!--</el-table-column>-->
        <el-table-column
          v-if="instructorType === 'pro' || instructorType === 'institutionNonLTI'"
          header-align="center"
          align="center"
          width="100"
          prop=""
          label="Monitor">
          <template slot-scope="scope">
            <v-btn icon flat class="branded-text" @click="lmbMonitorNav(scope.row)" :disabled="!lmb.headers.config.lmb.share || !scope.row.lmb_bulb_id || scope.row.complete === 0">
              <v-icon class="branded-text" >view_list</v-icon>
            </v-btn>
          </template>
        </el-table-column>
        <el-table-column
          header-align="center"
          align="center"
          width="100"
          prop=""
          label="Copy">
          <template slot-scope="scope">
            <v-btn icon flat class="branded-text" @click="handleDialogOpen({type:'copyMenu' , data:{name: `${gradebookBreadcrumbs[0].text}-${scope.row.student_name}`, id:scope.row.lmb_bulb_id, thumbnail:'//cdn.playposit.com/image-uploads/image-22-05-2019-15-38-38--lmb.jpg', copyLmbData: false}})" :disabled="!scope.row.complete || scope.row.complete === 0">
              <v-icon tabIndex="0" aria-label="Copy the bulb" class="branded-text" >file_copy</v-icon>
            </v-btn>
          </template>
        </el-table-column>
        <template slot="empty">
          <h1>No Data</h1>
        </template>
      </el-table>

      <!--Learner-Made-Bulb-Monitor table-->
      <el-table
      v-if="activeViewInstructor === 'Learner-Made-Bulb-Monitor' && dynamicDataLoaded"
      :data="interactions.data"
      :header-cell-class-name="sortClasses"
      style="width: 100%"
      :max-height="maxHeight"
      @selection-change="selectionChange"
      @sort-change="sortChange"
      >
        <el-table-column
          fixed
          sortable="custom"
          prop="student_name"
          label="Learner Name"
          min-width="200">
        </el-table-column>
        <el-table-column
          header-align="center"
          align="center"
          min-width= "100"
          prop="score"
          label="Score">
        </el-table-column>
        <el-table-column
          width= "150"
          header-align="center"
          prop="status"
          label="Status">
          <template slot-scope="scope" >
            <div class="column">
              <el-tag v-if="!scope.row.complete && scope.row.complete != 0" type="danger">{{scope.row.status}}</el-tag>
              <el-tag v-if="scope.row.complete === 0" type="warning">{{scope.row.status}}</el-tag>
              <el-tag v-if="scope.row.complete === 1" type="success" class="cursor">{{scope.row.status}}</el-tag>
            </div>
          </template>
        </el-table-column>
        <el-table-column
          v-for="question in interactions.headers"
          :prop="question.interaction_id"
          :label="question.interaction_type"
          width="150"
          align="center"
          :key="question.interaction_id"
          >
          <template slot="header" slot-scope="scope" v-if="popoverReset">
            <div class="question-header">
              <el-popover trigger="click" placement="bottom"  width="170">
                <div>
                  <!--<div  class="action-button">-->
                  <!--  <v-btn flat text class="branded-grey"  @click="gradeInteraction({property: question.interaction_id})" >Grade All</v-btn>-->
                  <!--</div>-->
                  <div class="action-button">
                    <v-btn flat text  class="branded-grey" @click="openInteractionModal(question)">
                      <v-icon small style="padding-right: 8px;">insert_chart</v-icon>
                      Interaction Data
                    </v-btn>
                  </div>
                </div>
                <div slot="reference" class="interaction-header">
                  <button :aria-label="`${question.interaction_type} question`"  class="interaction-question-icon cursor">
                    <v-icon>{{interactionIconMap[question.interaction_type]}}</v-icon>
                    <h5 class="cursor question-timestamp" aria-hidden="true">{{question.display_in_time}}</h5>
                  </button>
                </div>
              </el-popover>
            </div>
          </template>
          <template slot-scope="scope" v-if="popoverReset">
             <el-popover trigger="click" placement="left"  width="500" :disabled="!scope.row[question.interaction_id]"  v-if="popoverReset" @show="toggleOnViewer(scope.row[question.interaction_id].interaction_attempt_id)">
                <div :class="question.interaction_type === 'free_response' ? 'popover-scroll' : ''">
                  <div class="question_header">
                    <v-icon color="white">{{interactionIconMap[question.interaction_type]}}</v-icon>
                    <span>Points: {{scope.row[question.interaction_id] ? scope.row[question.interaction_id].points_earned : '-'}}  / {{scope.row[question.interaction_id] ? scope.row[question.interaction_id].points_available : '-'}}</span>
                    <span v-if="question.interaction_type != 'discussion_q'">Engagement (sec): {{scope.row[question.interaction_id] ? scope.row[question.interaction_id].time_elapsed : '-'}}</span>
                  </div>
                  <div class="question-popover" v-if="scope.row[question.interaction_id]">
                    <div style="height:350px; width: 100%;" aria-live="polite">
                      <!-- Will/Luke/Clayton got on a call and came to the conclusion that this is no longer applicable...? -->
                      <PlaypositInteraction
                        v-if="interactionAttemptShow === `Learner-Made-Bulb-Monitor-${scope.row[question.interaction_id].interaction_attempt_id}`"
                        :bulb-id="parseInt(queryParamsInstructors.lmb_bulb, 10)"
                        :section-id="parseInt(queryParamsInstructors.lmb_section, 10)"
                        :student-id="parseInt(scope.row.id, 10)"
                        :teacher-id="instructorData.id"
                        :interactionId="parseInt(question.interaction_id, 10)"
                        :setViewedComments="setViewedComments"
                        :token="instructorData.token"
                        :restrict-discussion-comments-by-student-id="scope.row.id"
                        user-type="teacher"
                        discussion-role="observer"
                        perspective="answered"
                      />

                    </div>
                  </div>
                  <v-divider></v-divider>
                  <div class="question_footer">
                    <div class="question_footer_points">
                      <span :style="scope.row[question.interaction_id] ? questionFooterPointsStyle(scope.row[question.interaction_id].points_earned, scope.row[question.interaction_id].points_available ) : ''">{{scope.row[question.interaction_id] ? scope.row[question.interaction_id].points_earned : '-'}}  / {{scope.row[question.interaction_id] ? scope.row[question.interaction_id].points_available : '-'}} pts</span>
                    </div>
                    <div class="question_footer_radio">
                      <el-radio-group v-if="scope.row[question.interaction_id] && scope.row[question.interaction_id].points_available > 0" v-model="scope.row[question.interaction_id].points_earned" @change="saveGrade(scope.row[question.interaction_id].points_earned, scope.row[question.interaction_id].interaction_attempt_id, scope.row[question.interaction_id].explanation, null, scope.row.bulbattempt_id)">
                        <el-radio-button  label=0>0</el-radio-button>
                        <el-radio-button v-for="i in scope.row[question.interaction_id].points_available" :label="i" :key="i">{{i}}</el-radio-button>
                      </el-radio-group>
                    </div>
                  </div>
                </div>
                <div slot="reference" :class="scope.row[question.interaction_id] ? 'cursor popup' : ''">
                  <div v-if="scope.row[question.interaction_id]" class="mt-3">
                    <GradeCell
                      user-type="teacher"
                      :question="question"
                      :data="scope.row[question.interaction_id]"
                      :view="activeViewInstructor"
                    ></GradeCell>
                  </div>
                  <div v-else>
                    <span>-</span>
                  </div>
                </div>
              </el-popover>
          </template>
        </el-table-column>
        <template slot="empty">
          <h1>No Data</h1>
        </template>
      </el-table>


      <!--peer review table-->
      <el-table
      v-if="activeViewInstructor === 'Peer-Review' && dynamicDataLoaded"
      :data="peerreview.data"
      :header-cell-class-name="sortClasses"
      style="width: 100%"
      :max-height="maxHeight"
      @sort-change="sortChange"
      @selection-change="selectionChange"
      >
        <el-table-column
          type="selection"
          width="55"
          align="center"
        >
        </el-table-column>
        <el-table-column
          fixed
          sortable="custom"
          prop="student_name"
          label="Learner Name"
          min-width="200">
        </el-table-column>
        <el-table-column
          :width= "peerreview.headers.groups ? '250' : '5'"
          header-align="center"
          prop="group"
          :label="peerreview.headers.groups ? 'Group' : ''">
          <template slot-scope="scope" >
            <div class="column">
              <el-tag  type="info" v-if="peerreview.headers.groups">{{scope.row.group}}</el-tag>
            </div>
          </template>
        </el-table-column>
        <!--<el-table-column-->
        <!--  width= "250"-->
        <!--  header-align="center"-->
        <!--  prop=""-->
        <!--  label="Status">-->
        <!--  <template slot-scope="scope" >-->
        <!--    <div class="column">-->
        <!--       <div>-->
        <!--         <span>Submission: {{scope.row.submissionStatus}}</span>-->
        <!--       </div>-->
        <!--       <div>-->
        <!--         <span>Peer Review: {{scope.row.peerReviewStatus}}</span>-->
        <!--       </div>-->
        <!--    </div>-->
        <!--  </template>-->
        <!--</el-table-column>-->
        <el-table-column
          prop="score"
          label="Score"
          min-width="200">
          <template slot-scope="scope">
            <el-radio-group v-if="editGrades && scope.row.points_available && scope.row.bulb_attempt_id && scope.row.complete == 1" v-model="scope.row.points_earned" @change="saveLMBGrade({bulb_attempt: scope.row.bulb_attempt_id, points_earned: scope.row.points_earned})">
              <el-radio-button  :label="scope.row.points_available - scope.row.points_available" >0</el-radio-button>
              <el-radio-button v-for="i in scope.row.points_available" :label="i" :key="i">{{i}}</el-radio-button>
            </el-radio-group>
            <span v-if="!editGrades">{{scope.row.score}}</span>
          </template>
        </el-table-column>
        <el-table-column
          v-if="!peerreview.headers.config.lmb.pr_rubric"
          header-align="center"
          align="center"
          width="100"
          prop=""
          label="Preview">
          <template slot-scope="scope">
            <v-btn icon flat class="branded-text" @click="playLMB({id:scope.row.lmb_id, section_id: scope.row.lmb_section_id})" :disabled="!scope.row.complete && (scope.row.complete != 0)">
              <v-icon tabIndex="0" aria-label="Play bulb" class="branded-text" >play_circle_outline</v-icon>
            </v-btn>
          </template>
        </el-table-column>
        <el-table-column
          header-align="center"
          align="center"
          width="100"
          prop=""
          label="Copy">
          <template slot-scope="scope">
            <v-btn icon flat class="branded-text" @click="copyLMB(scope.row)" :disabled="!scope.row.complete && scope.row.complete != 0">
              <v-icon tabIndex="0" aria-label="Copy bulb" class="branded-text" >file_copy</v-icon>
            </v-btn>
          </template>
        </el-table-column>
        <el-table-column
          header-align="center"
          align="center"
          width="100"
          prop=""
          label="Rubric">
          <template slot-scope="scope">
            <v-btn icon flat class="branded-text" @click="slideOutLarge('peer-review', scope.row)" :disabled="!peerreview.headers.config.lmb.pr_rubric || !scope.row.lmb_id  || (scope.row.complete === null  || scope.row.complete === 0)">
              <v-icon tabIndex="0" aria-label="Open rubric" class="branded-text" >dns</v-icon>
            </v-btn>
          </template>
        </el-table-column>
        <template slot="empty">
          <h1>No Data</h1>
        </template>
      </el-table>

      <!--student bulb attempts table-->
      <el-table
      v-if="activeViewInstructor === 'Student-Bulb-Attempts' && dynamicDataLoaded"
      :data="studentbulbattempts.data"
      style="width: 100%"
      :max-height="maxHeight"
      :header-cell-class-name="sortClasses"
      @sort-change="sortChange"
      >
        <el-table-column
          prop="thumbnail"
          label=""
          align="center"
          width="75">
          <template slot-scope="scope">
            <div class="column" style="height:50px;">
              <v-responsive :aspect-ratio="16/9"  height="36px" width="64px" max-height="36px" max-width="64px">
                <button aria-label="Bulb thumbnail" class="thumbnail-wrapper"><img style="width: 100%; height: 100%" :src="scope.row.thumbnail"/></button>
              </v-responsive>
            </div>
          </template>
        </el-table-column>
        <el-table-column
          prop="name"
          label="Bulb Name"
          sortable="custom"
          align="center"
          width="300">
          <template slot-scope="scope">
            <span class="selectable" v-if="!scope.row.lmb_id" @click="studentInteractionNav(scope.row)">{{scope.row.name}}</span>
            <span v-if="scope.row.lmb_id == 1">{{scope.row.name}}</span>
          </template>
        </el-table-column>
        <el-table-column
          min-width= "150"
          align="center"
          header-align="center"
          prop="points"
          label="Points">
        </el-table-column>
        <el-table-column
          width= "100"
          header-align="center"
          align="center"
          prop="score"
          sortable="custom"
          label="Score">
        </el-table-column>
        <el-table-column
          prop="engaged_minutes"
          header-align="center"
          align="center"
          sortable="custom"
          width="175"
          label="Time Spent (min)">
        </el-table-column>
        <el-table-column
          min-width= "250"
          header-align="center"
          prop="status"
          label="Status">
          <template slot-scope="scope" >
            <div class="column">
              <el-tag v-if="!scope.row.complete && scope.row.complete != 0" type="danger">{{scope.row.status}}</el-tag>
              <el-tag v-if="scope.row.complete === 0" type="warning">{{scope.row.status}}</el-tag>
              <el-tag v-if="scope.row.complete === 1" type="success">{{scope.row.status}}</el-tag>
            </div>
          </template>
        </el-table-column>
        <template slot="empty">
          <h1>No Data</h1>
        </template>
      </el-table>


      <!--student interaction table-->
      <el-table
      v-if="activeViewInstructor === 'Student-Interaction' && dynamicDataLoaded"
      :data="studentinteraction.data"
      :header-cell-class-name="sortClasses"
      @sort-change="sortChange"
      style="width: 100%"
      :max-height="maxHeight"
      :row-class-name="rowHeight"
      >
        <el-table-column
          prop=""
          label=""
          align="center"
          width="70">
          <template slot-scope="scope" v-if="popoverReset">
            <div class="question-header">
              <el-popover v-model="menus.studentInteraction[parseInt(scope.row.interaction_id, 10)]" trigger="click" placement="right"  width="375">
                <div class="popover-content-wrapper">
                  <PlaypositInteraction
                    v-if="menuData.studentInteraction[parseInt(scope.row.interaction_id, 10)]"
                    :bulb-id="parseInt($route.query.bulb_id, 10)"
                    :section-id="parseInt($route.query.section_id, 10)"
                    :interaction-id="parseInt(scope.row.interaction_id, 10)"
                    :teacher-id="instructorData.id"
                    :token="instructorData.token"
                    :setViewedComments="setViewedComments"
                    topper="typeAndTimestamp"
                    user-type="teacher"
                    discussion-role="observer"
                    perspective="displayMaximum"
                  />
                </div>
                <el-tag type="info" slot="reference" class="center" >
                  <v-icon tabIndex="0" aria-label="Open interaction information" class="cursor">{{interactionIconMap[scope.row.interaction_type]}}</v-icon>
                </el-tag>
              </el-popover>
            </div>
          </template>
        </el-table-column>
        <el-table-column
          prop="display_in_time"
          label="Interaction Time"
          header-align="center"
          align="center"
          width="150">
        </el-table-column>
        <el-table-column
          v-if="!editGrades"
          width="150"
          align="center"
          header-align="center"
          prop="time_elapsed"
          label="Time Spent (sec)">
        </el-table-column>
        <el-table-column
          header-align="center"
          align="center"
          prop="points"
          label="Points"
          :width="editGrades? 325 : 200"
          >
          <template slot-scope="scope">
            <el-radio-group v-if="editGrades && scope.row.points_available" v-model="scope.row.points_earned" @change="saveGrade(scope.row.points_earned, scope.row.interaction_attempt_id, scope.row.explanation)">
              <el-radio-button  :label="scope.row.points_available - scope.row.points_available" >0</el-radio-button>
              <el-radio-button v-for="i in scope.row.points_available" :label="i" :key="i">{{i}}</el-radio-button>
            </el-radio-group>
            <span v-if="!editGrades">{{scope.row.points}}</span>
          </template>
        </el-table-column>
        <el-table-column
          min-width= "200"
          header-align="center"
          align="center"
          prop="response.text"
          label="Answer">
          <template slot-scope="scope" v-if="popoverReset">
            <el-popover
              v-model="menus.studentInteraction2[parseInt(scope.row.interaction_id, 10)]"
              trigger="click"
              placement="left"
              width="500"
              v-if="scope.row.interaction_attempt_id"
              @show="toggleOnViewer(scope.row.interaction_attempt_id)"
            >
              <div :class="scope.row.interaction_type === 'free_response' ? 'popover-scroll' : ''">
                <div class="popover-content-wrapper" aria-live="polite">
                  <PlaypositInteraction
                    v-if="menuData.studentInteraction2[parseInt(scope.row.interaction_id, 10)]"
                    :bulb-id="parseInt(queryParamsInstructors.bulb_id, 10)"
                    :section-id="parseInt(queryParamsInstructors.section_id, 10)"
                    :student-id="parseInt(queryParamsInstructors.student_id, 10)"
                    :teacher-id="instructorData.id"
                    :interactionId="parseInt(scope.row.interaction_id, 10)"
                    :setViewedComments="setViewedComments"
                    :token="instructorData.token"
                    :restrict-discussion-comments-by-student-id="queryParamsInstructors.student_id"
                    topper="typeAndTimestamp"
                    user-type="teacher"
                    discussion-role="observer"
                    perspective="answered"
                  />
                </div>
                <v-divider></v-divider>
                <div>
                  <InstructorQuestionFooter
                    :bulbId="parseInt(queryParamsInstructors.bulb_id, 10)"
                    :sectionId="queryParamsInstructors.section_id"
                    :instructorData="instructorData"
                    :interactionData="scope.row"
                    :interactionAttemptShow="interactionAttemptShow"
                    :interactionType="scope.row.interaction_type"
                    :hidePointFooter="true"
                    :footerKey="footerCounter"
                  />
                </div>
              </div>
              <div v-if="scope.row.interaction_attempt_id ? scope.row.interaction_type != 'free_response': false" slot="reference" tabIndex="0" aria-label="Show answer" class="cursor row-center popup mt-3">
                <GradeCell
                  class="center"
                  question="student"
                  user-type="teacher"
                  :data="scope.row"
                  :view="activeViewInstructor"
                ></GradeCell>
              </div>
              <div v-if="scope.row.interaction_attempt_id ? scope.row.interaction_type === 'free_response' : false" slot="reference" class="cursor row-center">
                <div class="free-response-wrapper">
                  <div :class="scope.row.response_text ? 'free-response-answer' : ''" v-dompurify-html="scope.row.response_text"></div>
                  <v-btn
                    icon
                    flat
                    v-if="scope.row.response_text
                    && isSchoolUser"
                    small color="primary" class="ml-3"
                  >
                    <v-icon tabIndex="0" aria-label="Leave free response feedback" small>chat_bubble</v-icon>
                  </v-btn>
                </div>
              </div>
            </el-popover>
          </template>
        </el-table-column>
        <el-table-column
          header-align="center"
          prop="explanation"
          :label="editGrades ? 'Explanation' : ''"
          :width="editGrades ? '200' : '1'">
          <template slot-scope="scope">
            <div v-if="editGrades" :class="scope.row.explanation ? 'free-response-answer' : ''">{{scope.row.explanation}}</div>
          </template>
        </el-table-column>
        <template slot="empty">
          <h1>No Data</h1>
        </template>
      </el-table>

      <!--single interaction table-->
      <el-table
      v-if="activeViewInstructor === 'Single-Interaction' && dynamicDataLoaded"
      :data="singleinteraction.data"
      :header-cell-class-name="sortClasses"
      style="width: 100%"
      :max-height="maxHeight"
      @sort-change="sortChange"
      >
        <el-table-column
          prop="student_name"
          label="Learner Name"
          sortable="custom"
          width="200">
        </el-table-column>
        <el-table-column
          v-if="!editGrades"
          align="center"
          header-align="center"
          prop="time_elapsed"
          label="Time Spent (sec)"
          width="150">
        </el-table-column>
        <el-table-column
          header-align="center"
          align="center"
          prop="points"
          label="Points"
          sortable="custom"
          :width="editGrades? 325 : 200"
          >
          <template slot-scope="scope">
            <el-radio-group v-if="editGrades && scope.row.points_available" v-model="scope.row.points_earned" @change="saveGrade(scope.row.points_earned, scope.row.interaction_attempt_id, scope.row.explanation, scope.row.id)">
              <el-radio-button  :label="scope.row.points_available - scope.row.points_available">0</el-radio-button>
              <el-radio-button v-for="i in scope.row.points_available" :label="i" :key="i">{{i}}</el-radio-button>
            </el-radio-group>
            <span v-if="!editGrades">{{scope.row.points}}</span>
            <span v-if="scope.row.archivedAttempt" style="font-size:20px; position:absolute; top:10px">*</span>
          </template>
        </el-table-column>
        <el-table-column
          v-for="bank in (singleinteraction.headers.banks || [{interactionId: queryParamsInstructors.interaction_id}])"
          :key="bank.id"
          min-width= "200"
          header-align="center"
          align="center"
          sortable="custom"
          prop="response.text"
          label="Answer"
        >
          <template slot-scope="scope" v-if="popoverReset">
            <div
              v-if="(
                scope.row.interaction_attempt_id
                && scope.row.interaction_id !== bank.interactionBank.interactionId
              )"
              class="center"
            >
              <span class='el-tag el-tag--clear'>N/A</span>
            </div>
            <el-popover
              v-else
              trigger="click"
              placement="top"
              width="500"
              :disabled="!scope.row.interaction_attempt_id"
              @show="toggleOnViewer(scope.row.interaction_attempt_id)"
            >
              <div :class="scope.row.interaction_type === 'free_response' ? 'popover-scroll' : ''">
                <div class="question_header">
                  <span>Student: {{scope.row.student_name}}</span>
                </div>
                <div
                  class="question-popover"
                  v-if="scope.row.interaction_attempt_id"
                >
                  <div style="height:350px; width:100%;" aria-live="polite">
                    <PlaypositInteraction
                      v-if="interactionAttemptShow === `Single-Interaction-${scope.row.interaction_attempt_id}`"
                      :bulb-id="parseInt(queryParamsInstructors.bulb_id, 10)"
                      :section-id="parseInt(queryParamsInstructors.section_id, 10)"
                      :student-id="parseInt(scope.row.id, 10)"
                      :teacher-id="instructorData.id"
                      :interactionId="parseInt(scope.row.interaction_id, 10)"
                      :token="instructorData.token"
                      :setViewedComments="setViewedComments"
                      :restrict-discussion-comments-by-student-id="scope.row.id"
                      user-type="teacher"
                      discussion-role="observer"
                      perspective="answered"
                    />
                  </div>
                </div>
                <v-divider></v-divider>
                <div>
                  <InstructorQuestionFooter
                    :bulbId="parseInt(queryParamsInstructors.bulb_id, 10)"
                    :sectionId="queryParamsInstructors.section_id"
                    :instructorData="instructorData"
                    :interactionData="scope.row"
                    :interactionAttemptShow="interactionAttemptShow"
                    :interactionType="scope.row.interaction_type"
                    :saveGrade="saveGrade"
                    :footerKey="footerCounter"
                  />
                </div>
              </div>
              <div
                v-if="!scope.row.interaction_attempt_id"
                slot="reference"
                class="cursor row-center"
              >
                <div class="center"><span class='el-tag el-tag--clear'>-</span></div>
              </div>
              <div
                v-if="scope.row.interaction_attempt_id ? scope.row.interaction_type != 'free_response': false"
                slot="reference"
                class="cursor row-center popup mt-3"
              >
                <GradeCell
                  class="center"
                  question="single"
                  user-type="teacher"
                  :data="scope.row"
                  :view="activeViewInstructor"
                  :show-points-badges="filtersInteraction.showPointsBadges"
                ></GradeCell>
              </div>
              <div
                v-if="scope.row.interaction_attempt_id ? scope.row.interaction_type === 'free_response' : false"
                slot="reference"
                class="cursor d-flex justify-start"
                style="width: 100%;"
              >
                <div class="free-response-wrapper">
                  <div
                    :class="scope.row.response_text ? 'free-response-answer' : ''"
                    v-dompurify-html="scope.row.response_text">
                  </div>
                  <v-btn 
                    icon
                    flat
                    v-if="scope.row.response_text 
                    &&  isSchoolUser" 
                    small color="primary" class="ml-3"
                  >
                    <v-icon tabIndex="0" aria-label="Show free-response answer" small>chat_bubble</v-icon>
                  </v-btn>
                </div>
              </div>
            </el-popover>
          </template>
        </el-table-column>
        <!-- <el-table-column
          header-align="center"
          prop="explanation"
          :label="editGrades ? 'Explanation' : ''"
          :width="editGrades ? '200' : '1'">
          <template slot-scope="scope">
            <div v-if="editGrades" :class="scope.row.explanation ? 'free-response-answer' : ''">{{scope.row.explanation}}</div>
          </template>
        </el-table-column> -->
        <template slot="empty">
          <h1>No Data</h1>
        </template>
      </el-table>


      <!--premade bulbs table-->
      <el-table
      v-if="activeViewInstructor === 'Premade-Bulbs' && dynamicDataLoaded"
      :data="premade.data"
      :cell-class-name="thumbnailColumn"
      :header-cell-class-name="sortClasses"
      @sort-change="sortChange"
      style="width: 100%"
      :max-height="maxHeight"
      >
        <el-table-column
          v-if="!isPremadePlaylists"
          prop="thumbnail"
          label=""
          align="center"
          width="80">
          <template slot-scope="scope" v-if="popoverReset">
            <el-popover
              trigger="click"
              placement="left"
              :disabled="instructorAjaxing"
              width="175"
              @show="handlePopoverShow">
              <div>
                <div class="action-button">
                  <v-btn flat text class="branded-grey class-button"  @click="playPremade(scope.row.id)" >
                    <v-icon small  style="padding-right: 8px;">play_circle_outline</v-icon>
                    Preview
                  </v-btn>
                </div>
                <div class="action-button">
                  <v-btn flat text  class="branded-grey class-button"  @click="exportWorksheet(scope.row.id)">
                    <v-icon small  style="padding-right: 8px;">description</v-icon>
                    Export Worksheet
                  </v-btn>
                </div>
                <div class="action-button">
                  <v-btn
                    @click="instructorData.migrated ? null : handleDialogOpen({type: 'copyMenu' , data: { ...scope.row, isCopyingUnrestricted: true }})"
                    :disabled="!!instructorData.migrated"
                    flat
                    text
                    :class="instructorData.migrated ? null : 'branded-grey'"
                  >
                    <v-icon
                      small
                      class="pr-2"
                    >
                      file_copy
                    </v-icon>
                    Copy
                  </v-btn>
                </div>
              </div>
              <div slot="reference" >
                <div class="column" style="height:50px;">
                  <v-responsive :aspect-ratio="16/9"  height="36px" width="64px" max-height="36px" max-width="64px">
                    <button class="thumbnail-wrapper"><img tabIndex="0" aria-label="More options" style="width: 100%; height: 100%" :src="scope.row.thumbnail"/></button>
                  </v-responsive>
                </div>
              </div>
            </el-popover>
          </template>
        </el-table-column>
        <el-table-column
          v-else
          prop=""
          label=""
          align="center"
          width="80">
          <template slot-scope="scope">
            <ActionMenu :menu="'premade'" :playlist="scope.row"></ActionMenu>
          </template>
        </el-table-column>
        <el-table-column
          min-width= "200"
          sortable="custom"
          prop="name"
          :label="isPremadePlaylists ? 'Playlist Name' : 'Bulb Name'">
          <template slot-scope="scope">
            <Tooltip top>
              <span
                :class="[ isSafari ? 'safari-bulb-name-truncate' : 'bulb-name-truncate' ]">
                {{ scope.row.name }}
              </span>
              <template v-slot:text>
                {{ scope.row.name }}
              </template>
            </Tooltip>
          </template>
        </el-table-column>
        <el-table-column
          min-width="275"
          header-align="center"
          align="center"
          prop=""
          label="Tags">
          <template slot-scope="scope">
            <div
              v-if="updateTags"
              class="learner-teacher-container">
              <el-tag
                @click="setKeywordFilter(tag)"
                v-for="(tag, index) in rowTags(scope.row)"
                :key="index"
                :style="tagStyle(tag)">
                {{tag.text}}
              </el-tag>
              <el-tag
                @click="showTags(scope.row)"
                v-if="_.get(scope, 'row.tags', scope.row.playlistTags).length > 3 && !showAllTags[scope.row.id]"
                tabIndex="0"
                aria-label="Show more tags"
                type="info"
                style="margin:5px; background-color:#fff; border-color: #fff;"
                class="cursor">
                ...
              </el-tag>
              <el-tag
                @click="showTags(scope.row)"
                v-if="rowTags(scope.row).length > 3 && showAllTags[scope.row.id]"
                type="info"
                style="margin:5px; background-color:#fff; border-color: #fff;"
                class="cursor">
                <v-icon small>
                  clear
                </v-icon>
              </el-tag>
            </div>
          </template>
        </el-table-column>
        <el-table-column
          min-width= "200"
          sortable="custom"
          header-align="center"
          align="center"
          prop="creator"
          label="Creator">
          <template slot-scope="scope">
            <span class ="selectable" tabIndex="0" :aria-label="`Show pre-made bulbs created by ${scope.row.creator}`" @click="premadeCreatorSearch(scope.row.teacher_id, scope.row.creator)">{{scope.row.creator}}</span>
          </template>
        </el-table-column>
         <el-table-column
          v-if="!isPremadePlaylists"
          sortable="custom"
          header-align="center"
          align="center"
          width="150"
          prop="rigor"
          label="Rigor">
          <template slot="header" slot-scope="scope">
             <el-popover trigger="hover" placement="right-start" width="300">
              <v-card elevation="0" height="300">
                <iframe src="https://knowledge.playposit.com/article/208-navigating-playposit-3-0?embed=true#rigor" style="width:100%; height:100%;"></iframe>
              </v-card>
              <v-icon slot="reference" class="branded-text" style="font-size:16px;">info</v-icon>
            </el-popover>
            <span>Rigor</span>
          </template>
          <template slot-scope="scope">
            <v-rating readonly half-increments :color="school.active_color" v-model="scope.row.rigor" small style="min-width:150px;"></v-rating>
          </template>
        </el-table-column>
        <el-table-column
          v-if="!isPremadePlaylists"
          width="110"
          sortable="custom"
          header-align="center"
          align="center"
          prop="view_count"
          label="Views">
        </el-table-column>
        <el-table-column
          v-if="!isPremadePlaylists"
          header-align="center"
          align="center"
          width="100"
          prop=""
          label="Actions">
          <template slot-scope="scope" v-if="popoverReset">
            <el-popover
              trigger="click"
              placement="left"
              :disabled="instructorAjaxing"
              width="175"
              @show="handlePopoverShow">
              <div>
                <div class="action-button">
                  <v-btn flat text class="branded-grey class-button"  @click="playPremade(scope.row.id)" >
                    <v-icon small  style="padding-right: 8px;">play_circle_outline</v-icon>
                    Preview
                  </v-btn>
                </div>
                <div class="action-button">
                  <v-btn flat text  class="branded-grey class-button"  @click="exportWorksheet(scope.row.id)">
                    <v-icon small  style="padding-right: 8px;">description</v-icon>
                    Export Worksheet
                  </v-btn>
                </div>
                <div class="action-button">
                  <v-btn
                    @click="instructorData.migrated ? null : handleDialogOpen({type: 'copyMenu' , data: { ...scope.row, isCopyingUnrestricted: true }})"
                    :disabled="!!instructorData.migrated"
                    flat
                    text
                    :class="instructorData.migrated ? null : 'branded-grey'"
                  >
                    <v-icon
                      small
                      class="pr-2"
                    >
                      file_copy
                    </v-icon>
                    Copy
                  </v-btn>
                </div>
              </div>
              <v-btn flat class="no-hover" slot="reference" >
                <v-icon tabIndex="0" aria-label="Actions" class="hover-white cursor padding branded-text">more_vert</v-icon>
              </v-btn>
            </el-popover>
          </template>
        </el-table-column>
        <el-table-column
          v-else
          prop=""
          label=""
          align="center"
          width="80">
          <template slot-scope="scope">
            <ActionMenu :menu="'premade'" :playlist="scope.row" :actionColumn="true"></ActionMenu>
          </template>
        </el-table-column>
        <template slot="empty">
          <h1>No Data</h1>
        </template>
      </el-table>

      <!--Premade Legacy table-->
      <el-table
      v-if="activeViewInstructor === 'Premade-Bulbs-Legacy' && dynamicDataLoaded"
      :data="premade.data"
      :cell-class-name="thumbnailColumn"
      :header-cell-class-name="sortClasses"
      @sort-change="sortChange"
      style="width: 100%"
      :max-height="maxHeight"
      >
        <el-table-column
          prop="thumbnail"
          label=""
          align="center"
          width="80">
          <template slot-scope="scope" v-if="popoverReset">
            <el-popover  trigger="click" placement="left" :disabled="instructorAjaxing" width="100">
              <div>
                <div class="action-button">
                  <v-btn flat text class="branded-grey class-button"  @click="playPremade(scope.row.id)" >
                    <v-icon small  style="padding-right: 8px;">play_circle_outline</v-icon>
                    Preview
                  </v-btn>
                </div>
                <div class="action-button">
                  <v-btn flat text class="branded-grey class-button"  @click="handleDialogOpen({type:'copyMenu', data: { ...scope.row, isCopyingUnrestricted: true }})" >
                    <v-icon small  style="padding-right: 8px;">file_copy</v-icon>
                    Copy
                  </v-btn>
                </div>
              </div>
              <div slot="reference" >
                <div class="column" style="height:50px;">
                  <v-responsive :aspect-ratio="16/9"  height="36px" width="64px" max-height="36px" max-width="64px">
                    <button class="thumbnail-wrapper"><img style="width: 100%; height: 100%" :src="scope.row.thumbnail"/></button>
                  </v-responsive>
                </div>
              </div>
            </el-popover>
          </template>
        </el-table-column>
        <el-table-column
          min-width= "200"
          sortable="custom"
          prop="title"
          label="Bulb Name">
          <template slot-scope="scope">
            <span class="selectable" @click="playPremade(scope.row.id)">{{scope.row.title}}</span>
          </template>
        </el-table-column>
        <el-table-column
          min-width= "200"
          sortable="custom"
          header-align="center"
          align="center"
          prop="creator"
          label="Creator">
          <template slot-scope="scope">
            <span class ="selectable" @click="premadeCreatorSearch(scope.row.teacher_id, scope.row.creator)">{{scope.row.creator}}</span>
          </template>
        </el-table-column>
        <el-table-column
          header-align="center"
          sortable="custom"
          align="center"
          width="150"
          prop="rating"
          label="Rating">
          <template slot-scope="scope">
            <v-rating readonly :color="school.active_color" v-model="scope.row.rating" small style="min-width:150px;"></v-rating>
          </template>
        </el-table-column>
        <el-table-column
          width="110"
          sortable="custom"
          header-align="center"
          align="center"
          prop="view_count"
          label="Views">
        </el-table-column>
        <el-table-column
          header-align="center"
          align="center"
          width="100"
          prop=""
          label="Actions">
          <template slot-scope="scope" v-if="popoverReset">
            <el-popover  trigger="click" placement="left" :disabled="instructorAjaxing" width="100">
              <div>
                <div class="action-button">
                  <v-btn flat text class="branded-grey class-button"  @click="playPremade(scope.row.id)" >
                    <v-icon small  style="padding-right: 8px;">play_circle_outline</v-icon>
                    Preview
                  </v-btn>
                </div>
                <div class="action-button">
                  <v-btn flat text class="branded-grey class-button"  @click="handleDialogOpen({type:'copyMenu', data: { ...scope.row, isCopyingUnrestricted: true }})" >
                    <v-icon small  style="padding-right: 8px;">file_copy</v-icon>
                    Copy
                  </v-btn>
                </div>
              </div>
              <v-btn flat class="no-hover" slot="reference" >
                <v-icon class="hover-white cursor padding branded-text">more_vert</v-icon>
              </v-btn>
            </el-popover>
          </template>
        </el-table-column>
        <template slot="empty">
          <h1>No Data</h1>
        </template>
      </el-table>

      <!--My Community table-->
      <el-table
      v-if="activeViewInstructor === 'My-Community' && dynamicDataLoaded"
      :data="community.data"
      :cell-class-name="thumbnailColumn"
      :header-cell-class-name="sortClasses"
      @sort-change="sortChange"
      style="width: 100%"
      :max-height="maxHeight"
      >
        <el-table-column
          v-if="!isPremadePlaylists"
          prop="thumbnail"
          label=""
          align="center"
          width="80">
          <template
            slot-scope="scope"
            v-if="popoverReset">
            <el-popover
              trigger="click"
              placement="left"
              :disabled="instructorAjaxing"
              width="175"
              @show="handlePopoverShow">
              <div>
                <div class="action-button">
                  <v-btn flat text class="branded-grey class-button"  @click="playPremade(scope.row.id)" >
                    <v-icon small  style="padding-right: 8px;">play_circle_outline</v-icon>
                    Preview
                  </v-btn>
                </div>
                <div class="action-button">
                  <v-btn flat text  class="branded-grey class-button"  @click="exportWorksheet(scope.row.id)">
                    <v-icon small  style="padding-right: 8px;">description</v-icon>
                    Export Worksheet
                  </v-btn>
                </div>
                <div class="action-button">
                  <v-btn
                    @click="instructorData.migrated ? null : handleDialogOpen({type: 'copyMenu' , data: { ...scope.row, isCopyingUnrestricted: true }})"
                    :disabled="!!instructorData.migrated"
                    flat
                    text
                    class="class-button"
                    :class="instructorData.migrated ? null : 'branded-grey'"
                  >
                    <v-icon
                      small
                      class="pr-2"
                    >
                      file_copy
                    </v-icon>
                    Copy
                  </v-btn>
                </div>
              </div>
              <div slot="reference" >
                <div class="column" style="height:50px;">
                  <v-responsive :aspect-ratio="16/9"  height="36px" width="64px" max-height="36px" max-width="64px">
                    <button class="thumbnail-wrapper"><img tabIndex="0" aria-label="More options" style="width: 100%; height: 100%" :src="scope.row.thumbnail"/></button>
                  </v-responsive>
                </div>
              </div>
            </el-popover>
          </template>
        </el-table-column>
        <el-table-column
          v-else
          prop=""
          label=""
          align="center"
          width="80">
          <template slot-scope="scope">
            <ActionMenu :menu="'premade'" :playlist="scope.row"></ActionMenu>
          </template>
        </el-table-column>
        <el-table-column
          min-width= "200"
          sortable="custom"
          prop="name"
          :label="isPremadePlaylists ? 'Playlist Name' : 'Bulb Name'">
          <template slot-scope="scope">
            <Tooltip top>
              <span
                :class="[ isSafari ? 'safari-bulb-name-truncate' : 'bulb-name-truncate' ]">
                {{ scope.row.name }}
              </span>
              <template v-slot:text>
                {{ scope.row.name }}
              </template>
            </Tooltip>
          </template>
        </el-table-column>
        <el-table-column
          min-width="275"
          header-align="center"
          align="center"
          prop=""
          label="Tags">
          <template slot-scope="scope">
            <div
              v-if="updateTags"
              class="learner-teacher-container">
              <el-tag
                v-for="(tag, index) in rowTags(scope.row)"
                @click="setKeywordFilter(tag)"
                :key="index"
                :style="tagStyle(tag)">
                {{tag.text}}
              </el-tag>
              <el-tag
                @click="showTags(scope.row)"
                v-if="_.get(scope, 'row.tags', scope.row.playlistTags).length > 3"
                tabIndex="0"
                aria-label="Show more tags"
                type="info"
                style="margin:5px; background-color:#fff; border-color: #fff;"
                class="cursor">
                <p
                  v-if="!showAllTags[scope.row.id]">
                  ...
                </p>
                <v-icon
                  v-else
                  small>
                  clear
                </v-icon>
              </el-tag>
            </div>
          </template>
        </el-table-column>
        <el-table-column
          min-width= "200"
          sortable="custom"
          header-align="center"
          align="center"
          prop="creator"
          label="Creator">
          <template slot-scope="scope">
            <span class ="selectable" tabIndex="0" :aria-label="`Show bulbs created by ${scope.row.creator}`" @click="premadeCreatorSearch(scope.row.teacher_id, scope.row.creator)">{{scope.row.creator}}</span>
          </template>
        </el-table-column>
        <el-table-column
          v-if="!isPremadePlaylists"
          header-align="center"
          align="center"
          sortable="custom"
          width="150"
          prop="rigor"
          label="Rigor">
          <template slot="header" slot-scope="scope">
             <el-popover trigger="hover" placement="right-start" width="300">
              <v-card elevation="0" height="300">
                <iframe src="https://knowledge.playposit.com/article/208-navigating-playposit-3-0?embed=true#rigor" style="width:100%; height:100%;"></iframe>
              </v-card>
              <v-icon slot="reference" class="branded-text" style="font-size:16px;">info</v-icon>
            </el-popover>
            <span>Rigor</span>
          </template>
          <template slot-scope="scope">
            <v-rating readonly half-increments :color="school.active_color" v-model="scope.row.rigor" small style="min-width:150px;"></v-rating>
          </template>
        </el-table-column>
        <el-table-column
          v-if="!isPremadePlaylists"
          width="110"
          sortable="custom"
          header-align="center"
          align="center"
          prop="view_count"
          label="Views">
        </el-table-column>
        <el-table-column
          v-if="!isPremadePlaylists"
          header-align="center"
          align="center"
          width="100"
          prop=""
          label="Actions">
          <template slot-scope="scope" v-if="popoverReset && !isPremadePlaylists">
            <el-popover
              trigger="click"
              placement="left"
              :disabled="instructorAjaxing"
              width="175"
              @show="handlePopoverShow">
              <div>
                <div class="action-button">
                  <v-btn flat text class="branded-grey class-button"  @click="playPremade(scope.row.id)" >
                    <v-icon small  style="padding-right: 8px;">play_circle_outline</v-icon>
                    Preview
                  </v-btn>
                </div>
                <div class="action-button">
                  <v-btn flat text  class="branded-grey class-button"  @click="exportWorksheet(scope.row.id)">
                    <v-icon small  style="padding-right: 8px;">description</v-icon>
                    Export Worksheet
                  </v-btn>
                </div>
                <div class="action-button">
                  <v-btn
                    @click="instructorData.migrated ? null : handleDialogOpen({type: 'copyMenu' , data: { ...scope.row, isCopyingUnrestricted: true }})"
                    :disabled="!!instructorData.migrated"
                    flat
                    text
                    class="class-button"
                    :class="instructorData.migrated ? null : 'branded-grey'"
                  >
                    <v-icon
                      small
                      class="pr-2"
                    >
                      file_copy
                    </v-icon>
                    Copy
                  </v-btn>
                </div>
              </div>
              <v-btn flat class="no-hover" slot="reference" >
                <v-icon tabIndex="0" aria-label="Actions" class="hover-white cursor padding branded-text">more_vert</v-icon>
              </v-btn>
            </el-popover>
          </template>
        </el-table-column>
        <el-table-column
          v-else
          prop=""
          label=""
          align="center"
          width="80">
          <template slot-scope="scope">
            <ActionMenu :menu="'premade'" :playlist="scope.row" :actionColumn="true"></ActionMenu>
          </template>
        </el-table-column>
        <template slot="empty">
          <h1>No Data</h1>
        </template>
      </el-table>

      <!--my community bulbs table-->
      <el-table
      v-if="activeViewInstructor === 'My-Community-Legacy' && dynamicDataLoaded"
      :data="community.data"
      :cell-class-name="thumbnailColumn"
      :header-cell-class-name="sortClasses"
      @sort-change="sortChange"
      style="width: 100%"
      :max-height="maxHeight"
      >
        <el-table-column
          prop="thumbnail"
          label=""
          align="center"
          width="80">
          <template slot-scope="scope" v-if="popoverReset">
            <el-popover  trigger="click" placement="left" :disabled="instructorAjaxing" width="100">
              <div>
                <div class="action-button">
                  <v-btn flat text class="branded-grey class-button"  @click="playPremade(scope.row.id)" >
                    <v-icon small  style="padding-right: 8px;">play_circle_outline</v-icon>
                    Preview
                  </v-btn>
                </div>
                <div class="action-button">
                  <v-btn flat text class="branded-grey class-button"  @click="handleDialogOpen({type:'copyMenu' , data:scope.row})" >
                    <v-icon small  style="padding-right: 8px;">file_copy</v-icon>
                    Copy
                  </v-btn>
                </div>
              </div>
              <div slot="reference" >
                <div class="column" style="height:50px;">
                  <v-responsive :aspect-ratio="16/9"  height="36px" width="64px" max-height="36px" max-width="64px">
                    <button class="thumbnail-wrapper"><img style="width: 100%; height: 100%" :src="scope.row.thumbnail"/></button>
                  </v-responsive>
                </div>
              </div>
            </el-popover>
          </template>
        </el-table-column>
        <el-table-column
          min-width= "200"
          sortable="custom"
          prop="title"
          label="Bulb Name">
        </el-table-column>
        <el-table-column
          min-width= "200"
          sortable="custom"
          header-align="center"
          align="center"
          prop="creator"
          label="Creator">
          <template slot-scope="scope">
            <span class ="selectable" @click="premadeCreatorSearch(scope.row.teacher_id, scope.row.creator)">{{scope.row.creator}}</span>
          </template>
        </el-table-column>
        <el-table-column
          header-align="center"
          align="center"
          sortable="custom"
          width="150"
          prop="rating"
          label="Rating">
          <template slot-scope="scope">
            <v-rating readonly :color="school.active_color" v-model="scope.row.rating" small style="min-width:150px;"></v-rating>
          </template>
        </el-table-column>
        <el-table-column
          width="110"
          sortable="custom"
          header-align="center"
          align="center"
          prop="view_count"
          label="Views">
        </el-table-column>
        <el-table-column
          header-align="center"
          align="center"
          width="100"
          prop=""
          label="Actions">
          <template slot-scope="scope" v-if="popoverReset">
            <el-popover  trigger="click" placement="left" :disabled="instructorAjaxing" width="100">
              <div>
                <div class="action-button">
                  <v-btn flat text class="branded-grey class-button"  @click="playPremade(scope.row.id)" >
                    <v-icon small  style="padding-right: 8px;">play_circle_outline</v-icon>
                    Preview
                  </v-btn>
                </div>
                <div class="action-button">
                  <v-btn flat text class="branded-grey class-button"  @click="handleDialogOpen({type:'copyMenu' , data:scope.row})" >
                    <v-icon small  style="padding-right: 8px;">file_copy</v-icon>
                    Copy
                  </v-btn>
                </div>
              </div>
              <v-btn flat class="no-hover" slot="reference" >
                <v-icon class="hover-white cursor padding branded-text">more_vert</v-icon>
              </v-btn>
            </el-popover>
          </template>
        </el-table-column>
        <template slot="empty">
          <h1>No Data</h1>
        </template>
      </el-table>
      
      <PlaylistTable
        v-if="activeViewInstructor === 'Playlists' && dynamicDataLoaded"
        :maxHeight="maxHeight"
        :handlePopoverShow="handlePopoverShow">
      </PlaylistTable>
      
    </div>
</template>

<script>
/*global _*/

// Core:
import {
  mapState,
  mapGetters,
  mapActions,
  mapMutations,
} from 'vuex';

// Custom Components:
import Discussion from '../Discussion';
import PlaylistTable from './tables/PlaylistTable';
import GradeCell from '../GradeCell';
import InstructorQuestionFooter from './InstructorQuestionFooter';
import ActionMenu from '../ActionMenu';
import InteractionResults from '@/components/modal-views/InteractionResults';

// Libraries / Plugins:
const moment = require('moment');
import { encodeURI } from 'js-base64';
const Color = require('color');
import * as focusTrap from 'focus-trap';

// Utilities:
import {
  addSortAccessibiltyEvents,
  getServerUrl,
  waitForElementToDisplay,
} from '@utilities';

import {
  INTERACTION_TYPES,
  MIGRATION_BATCHES,
} from '@Constants';

import Hashids from 'hashids';
const hashids = new Hashids('dachshund', 6, 'cdefhjkmnprtvwxy2345689');

export default {
  name: 'instructor-table-dynamic-component',
  components: {
    ActionMenu,
    Discussion,
    PlaylistTable,
    GradeCell,
    InstructorQuestionFooter,
    InteractionResults,
  },
  data() {
    return {
      emptySpace: ' ',
      showPopper: false,
      explanation_graded_single: {},
      explanation_grade_student: {},
      hasBulbAverageScore: false,
      showAllTags:{},
      updateTags: true,
      gradebookTableKey: 1,
      popoverReset: true,
      maxHeight: '',
      rigor: false,
      currentRow: null,
      interactionAttemptShow: null,
      multipleBulbsSelected: [],
      key: 1,
      menus: {
        studentInteraction: {},
        studentInteraction2: {},
      },
      footerCounter: 0,
      menuData: {
        studentInteraction: {},
        studentInteraction2: {},
      },
      trap: null,
      playlistGradebookMenu: {
        event: null,
        item: null,
        attempt: null,
      },
    };
  },
  computed: {
    ...mapState('instructors', [
      'embedded',
      'playlistAverage',
      'premadeFilterContentType',
      'sectionPlaylists',
      'showPointsMode',
    ]),
    ...mapGetters([
      'passbackLinking',
      'serverURL',
      'activeView',
      'breadcrumbs',
      'instructorData',
      'interactionIconMap',
      'interactionTypeMap',
      'dialogShow',
      'popoverToggles',
      'nodeApiPrefix',
      'LTIdata',
      'LTIlaunch',
      'LMSdata',
      'playerApiPrefix',
      'designerApiPrefix',
      'instructorType',
      'school',
      'legacy',
      'userAgent',
      'isProquestUser',
    ]),
    ...mapGetters('instructors', [
      'activeViewInstructor',
      'instructorAjaxing',
      'queryParamsInstructors',
      'selectedData',
      'editGrades',
      'dynamicDataLoaded',
      'classes',
      'bulbs',
      'folders',
      'students',
      'premade',
      'gradebook',
      'bulbattempts',
      'interactions',
      'studentbulbattempts',
      'singleinteraction',
      'studentinteraction',
      'gradebookBreadcrumbs',
      'refreshData',
      'videos',
      'discussion',
      'community',
      'filterString',
      'filterSearch',
      'lmb',
      'peerreview',
      'singlefolder',
      'subfolder',
      'reloadInteractionViewerId',
      'filtersInteraction',
      'hasInstructorLearnerSchoolInGradebook',
      'showFolderBatchSelection'
    ]),
    isPremadePlaylists() {
      return (
        (
          this.community.type === 'playlists'
          && this.activeViewInstructor === 'My-Community'
        )
        || (
          this.premade.type === 'playlists'
          && this.activeViewInstructor === 'Premade-Bulbs'
        )
      )
    },
    selectedClassRole() {
    if (this.queryParamsInstructors.section_id) {
      const selectedClass = _.find(this.classes.data, c => {
        return c.id === this.queryParamsInstructors.section_id;
      });
      return selectedClass.containerRole;
    }
    return null;
    },
    activeViewData: function(){
      //returns active view change and when data is loaded to create grade object (explanation_graded)
      return [this.activeViewInstructor, this.dynamicDataLoaded];
    },
    filtersOn: function() {
      return (
        this.filterSearch.creator_name != '' ||
        this.filterSearch.age.length > 0 ||
        this.filterSearch.subject.length > 0 ||
        this.filterSearch.keywords.length > 0 ||
        this.filterSearch.name.length > 0 ||
        this.filterSearch.creator.length > 0 ||
        this.filterSearch.bulbRole.length > 0 ||
        this.filterSearch.youtube != ''||
        this.filterSearch.legacy ||
        !this.filterSearch.all_district ||
        this.filterSearch.playlistRole.length > 0
      )
    },
    modalOpen: function(){
      return this.dialogShow.dash;
    },
    isPlaylistGradebook() {
      return (
        _.get(this.$route, 'query.playlistGradebook')
        && _.get(this.$route, 'query.playlistGradebook') !== 'All Bulbs'
        && !_.isNil(_.get(this.$route, 'query.playlistGradebook'))
      );
    },
    isSchoolUser() {
      // If there is a school.id show bulkSelect/CoOwners column
      if (_.get(this, 'school.id')) return true;
      // If school.id is null - hide bulkSelect/CoOwners column
      return false;
    },
    playlistSelected() {
      return _.find(this.sectionPlaylists, { 'id': parseInt(_.get(this.$route, 'query.playlistGradebook'), 10) });
    },
    isSafari() {
      return _.get(this, 'userAgent.browser.name', '').toLowerCase() === 'safari';
    },
    migrationBannerShowing() {
      return (
        (MIGRATION_BATCHES.ONE.includes(this?.instructorData?.id) || false) // currently not showing
        || this?.instructorData?.id === 11
      )
    },
  },
  methods:{
    handleEditClick(row) {
      if (this.instructorData.migrated) return;
      if (row.lmb_id != 1) {
        this.edit(row.id);
      } else {
        this.handleDialogOpen({
          type: 'lmbEdit',
          data: row,
        });
      }
    },
    initPlaylistGradebookMenu(event, item, attempt) {
      this.$set(this, 'playlistGradebookMenu', {
        event,
        item,
        attempt,
      });
    },
    test(content) {
      return content?.tags.length > 3 || content?.playlistTags.length > 3
    },
    moduleItemsNotAttempted(headers, attempts){
      const headerWithNoAttempts = headers.filter(header => !attempts.some(attempt => attempt.moduleItemId == header.p_item_id))
      return headerWithNoAttempts
    },
    log(...args) {
      console.log(...args);
    },
    ...mapActions([
      'passbackContent',
      'passbackBulb',
      'sendProquestData',
    ]),
    ...mapMutations('instructors', [
      'setSelectedData',
    ]),
    ...mapMutations([
      'handleDialogOpen',
      'setDashModal', 
      'triggerSnackbar',
      'setViewedComments',
    ]),
    ...mapMutations('instructors', [
      'toggleEditGrades'
    ]),
    averageBulbScore(averageScore, type) {
      if (
        type === 'bulb'
        && averageScore
        && averageScore > 0
        ) {
          this.hasBulbAverageScore = true;
          return `Average score: ${averageScore}%`;
      } else if (
        type === 'playlist'
        && _.isNumber(averageScore)
        ) {
          this.hasBulbAverageScore = true;
          return `Average score: ${averageScore}%`;
      }
      return '';
    },
    async exportWorksheet(bulbID) {
      const baseURL = getServerUrl();
      const exportWorksheetUrl = `${baseURL}print?type=worksheet&bulb_id=${bulbID}&token=${this.instructorData.token}`;
      const win = window.open(
        exportWorksheetUrl,
        '_blank',
        'height=800,width=800,left=10,top=10,scrollbars=yes,menubar=no'
      );
      win.focus();
    },
    async exportLearnerAttempt(studentID) {
      const exportURL = `${getServerUrl()}print?type=bulb_attempt&bulb_id=${this.$route.query.bulb_id}&section_id=${this.queryParamsInstructors.section_id}&student_id=${studentID}`;
      const win = window.open(exportURL, '_blank', 'height=800,width=800,left=10,top=10,scrollbars=yes,menubar=no');
      win.focus();
    },
    bulbScore(row) {
      // if playlist
      if (row.module_item_attempt_id){
        if (this.showPointsMode) {
          return row.ba_points ? row.ba_points : `${row.ba_points_earned || 0}/${row.ba_points_available}`;
        } else {
          return `${row.score}%`;
        }
      } else {
        if (this.showPointsMode) {
          return row.points ? row.points : `${row.pointsEarned || 0}/${row.pointsAvailable}`;
        } else {
          return row.score;
        }
      }
    },
    canSelectRow(row) {
      if (row.bulb_role !== 1 || row.lmb_id) return false;
      return true;
    },
    externalMonitorHotlink(data) {
      this.$store.dispatch('sendManualLog', {
        category:'my bulbs',
        action: 'monitor',
      });
      const queryParameters = {
        page: 1,
        per_page: 20,
        search: '',
        sort: '',
        all_data: true,
        interaction_id: '',
        interaction_type: '',
        student_id: '',
        folder_id: '',
        subfolder_id: '',
        lms_class: this.queryParamsInstructors.lms_class,
        lmb_bulb: '',
        lmb_section: '',
        section_id: this.queryParamsInstructors.section_id,
        bulb_id: data.id,
        breadcrumbs: encodeURI(JSON.stringify([
          {
            text: 'Classes',
            disabled: false,
            payload:'Classes'
          },
          {
            text: data.name,
            payload:''
          },
          {
            text:'My Bulbs',
            payload:'My-Bulbs'
          },
        ])),
        gradebook: encodeURI(JSON.stringify([{
          text: data.name,
          payload:'',
        }])),
      };
      let activeView;
      if(!data.lmb_id){
        activeView = 'Interactions';
      } else if (data.config.lmb.peer_review) {
        activeView = 'Peer-Review';
      } else {
        activeView = 'Learner-Made-Bulb';
      }
      window.open(`${window.location.origin}/dash/instructor/Classes/${activeView}${queryParameters.toQueryString()}`, '_blank');
    },
    async handlePopoverShow(e) { // When a popover is opened await nextTick then find the popover element that is active and set focus to it.
      await this.$nextTick();
      const popovers = document.getElementsByClassName('el-popper');
      const activePopover = _.find(popovers, (popover) => {
        if (_.get(popover, 'style.display') !== 'none') return popover;
      });
      await this.$nextTick();
      if (activePopover) {
        this.trap = focusTrap.createFocusTrap(activePopover, {
          clickOutsideDeactivates: true,
        });
        this.trap.activate();
      }
    },
    async launchStudentCertificate(studentId) {
      const baseURL = getServerUrl();
      const playlistHash = hashids.encode([this.playlistSelected.id, this.queryParamsInstructors.section_id]);
      const userHash = hashids.encode(studentId);
      window.open(`${baseURL}course/certificate/${playlistHash}/${userHash}/`, '_blank');
    },
    loadPlaylistAverageScore() {
      this.getPlaylistAverageScore(this.playlistSelected.id);
    },
    playlistHasAttempts(row) {
      return !_.isNull(row.id);
    },
    playlistScore(row) {
      let score;
      if (this.showPointsMode) {
        if (row.playlistAttempt.pointsAvailable > 0) score = `${row.playlistAttempt.pointsEarned}/${row.playlistAttempt.pointsAvailable}`;
        else {
          if (row.playlistAttempt.complete === 1) score = '100%';
          else score = '-';
        }
      } else {
        if (row.playlistAttempt.pointsAvailable > 0) score = `${Math.round((row.playlistAttempt.pointsEarned/row.playlistAttempt.pointsAvailable) * 100)}%`;
        else {
          if (row.playlistAttempt.complete === 1) score = '100%';
          else score = '-';
        }
      }
      return score;
    },
    isTeacherSectionArchived(teacherSectionArchivedDate) {
      const now = moment();
      const archivedDate = moment(teacherSectionArchivedDate);
      if (archivedDate > now) return false;
      return true;
    },
    isSectionArchived(section) {
      if (section.archived) {
        const sectionArchivedDate = moment(section.archived);
        if (sectionArchivedDate < moment()) return true;
      }
      return false;
    },
   
    //table navigation functions
    setNavData: function(array) {
      //set array data
      let active_view = array[0];
      let query_params = array [1];
      let breadcrumbText = array[2];
      let secondaryBreadcrumb = array[3];
      let lmsType = array[4]

      //declare breadcrumb and payload data
      let breadcrumb;
      let payload = {};
      let activeText = this.activeView.replace('-',' ');

      if(breadcrumbText != null){
        //if breadcrumbText is not null, add active view breadcrumb
        breadcrumb = [{text:this.activeView, payload:this.activeView}, {text:breadcrumbText, payload:''}];
        payload[this.activeView] = {route:'instructor', activeView:this.activeView, activeViewRoute:this.activeView, queryParams:{}, 
        breadcrumb:[{text:activeText, payload:''}]}
      } else if (secondaryBreadcrumb[0] != null){
        //if secondaryBreadcrumb is not null, sets active gradebook breadcrumb for bulb or student
        breadcrumb = this.breadcrumbs;
        breadcrumb.push(secondaryBreadcrumb[0]);
        payload[this.activeViewInstructor] = secondaryBreadcrumb[1];
      } else {
        //else, sets first level of gradebook breadcrumb
        breadcrumb = this.breadcrumbs;
        payload[this.activeViewInstructor] = secondaryBreadcrumb[1];
      }
      //sets breadcrumbs, query params, active view, and url
      this.$store.commit('updateBreadCrumbs' , [breadcrumb, payload]);
      if(this.activeViewInstructor != 'Gradebook' && this.activeViewInstructor != 'Interaction') this.$store.commit('instructors/resetQueryParams');

      //check for lms class
      if(query_params.section_id){
        this.classes.data.forEach(item => {
          if(item.id === query_params.section_id){
            if(item.lmsType != null && item.lmsType != 'Google' && item.lmsType != 'SchoologyFree'){
              query_params['lms_class'] = true;
            }
          }
        })
      };

      //close table popovers from hotlinks
      this.popoverReset = false;
      setTimeout(() => {this.popoverReset = true}, .5);

      this.$store.commit('instructors/clearAllFiltersNoReload');
      this.$store.commit('instructors/setQueryParams', query_params)
      this.$store.commit('instructors/setActiveView', [active_view]);
      this.$store.dispatch('instructors/updateUrl');
    },
    interactionByBulbNav:function(event){
      //nav for moving into interaction for bulb_id table
      if (
          event.property != 'student_name'
          && event.type != 'selection'
        ) {
            let bulb_data;
            let isPlaylist = false;

            //find bulb data from headers or from event.data if bulb monitor hotlink
            if(!event.data){
              this.gradebook.headers.forEach(item => {
                if(item.id === event.property){
                  bulb_data = item;
                }
                if(item.p_item_id == event.property && item.p_item_type == 'bulb'){
                  bulb_data = item;
                  isPlaylist = true;
                }
              })
            } else {
              bulb_data = event.data
            }
            //set breadcrumbs
            let breadcrumb;
            let payload;
            if(this.activeViewInstructor === "Bulbs") {
              this.$store.dispatch('sendManualLog',{category:'bulbs', action:'monitor bulb'});
              
              breadcrumb = {text:'Bulbs', payload:'Bulbs'};
              payload = {route:'instructor', activeView: 'Classes', activeViewRoute:'Bulbs', queryParams:{ section_id: this.queryParamsInstructors.section_id}, breadcrumb: this.breadcrumbs }
            } else {
              breadcrumb = {text:'Gradebook', payload:'Gradebook'};
              payload = {route:'instructor', activeView: 'Classes', activeViewRoute:'Gradebook', queryParams:{ section_id: this.queryParamsInstructors.section_id}, breadcrumb: this.breadcrumbs }
            }

            //sets gradebook breadcrumb for bulb name
            this.$store.commit('instructors/setGradebookBreadcrumbs', [{text:`Overview: ${event.label}`, payload: ''}])

            //calls setNavData depends on if LMB
            if(bulb_data.lmb_id == 1){
              if(bulb_data?.config?.lmb.peer_review){
                this.setNavData(['Peer-Review', {bulb_id: event.property, section_id: this.queryParamsInstructors.section_id}, null, [breadcrumb , payload]])
              } else {
                if (isPlaylist) {
                  this.setNavData(['Learner-Made-Bulb', { bulb_id: bulb_data.b_id, section_id: this.queryParamsInstructors.section_id }, null, [breadcrumb, payload]])
                } else {
                  this.setNavData(['Learner-Made-Bulb', {bulb_id: event.property, section_id: this.queryParamsInstructors.section_id}, null, [breadcrumb , payload]])
                }
              }
            } else {
              if(isPlaylist){
                this.setNavData(['Interactions', {bulb_id: bulb_data.b_id, section_id: this.queryParamsInstructors.section_id}, null, [breadcrumb , payload]])
              } else{
                this.setNavData(['Interactions', {bulb_id: event.property, section_id: this.queryParamsInstructors.section_id}, null, [breadcrumb , payload]])
              }
            }
          }
    },
    studentByBulbNav:function(row){
      //nav for moving into student bulb attempts table for student_id
      //sets active gradebook breadcrumb for main breadcrumbs
      let breadcrumb = {text:'Gradebook', disabled:false, payload:'Gradebook'};
      let payload = {route:'instructor', activeView: 'Classes', activeViewRoute:'Gradebook', queryParams:{ section_id: this.queryParamsInstructors.section_id}, breadcrumb: this.breadcrumbs }
      //sets gradebook breadcrumb with student name
      this.$store.commit('instructors/setGradebookBreadcrumbs', [{text:row.student_name,  payload: ''}])
      //resets query params due to table type change
      this.$store.commit('instructors/setQueryParams', {page:1, per_page: 20, sort:'', search: ''});
      //calls setNavData
      this.setNavData(['Student-Bulb-Attempts', {section_id: this.queryParamsInstructors.section_id, student_id: row.id}, null, [breadcrumb , payload]])
    },
    singleInteractionNav:function(event){
      //nav for moving into single interaction table
      if(event.property != 'score' && event.property != 'student_name' && event.type != 'selection' && event.property != 'status'){
        //copies gradebook breadcrumbs to be able to manipulate
        let gradebookBreadcrumbsCopy = {};
        /*
          If `this.queryParamsInstructors.isProquest` is true, then we don't show the breadcrumbs anyways. Since Proquest will most likely end up going directly to the monitor page (and thus their URLs won't have breadcrumbs), I felt it made sense to just sidestep this logic entirely.
        */
        if (!this.queryParamsInstructors?.isProquest) {
          gradebookBreadcrumbsCopy = this.gradebookBreadcrumbs.slice();
          //creates payload for gradebook breadcrumb to return to full bulb interaction view
          gradebookBreadcrumbsCopy[0].payload = "Interactions";
          //finds time to be added as interaction specific gradebook breadcrumb
          let time;
          this.interactions.headers.forEach(item => {
            if(item.interaction_id === event.property) time = item.display_in_time;
          })
          //pushes time breadcrumb into gradebookBreadcrumb copy
          gradebookBreadcrumbsCopy.push({text:`Interaction at ${time}`,  payload: ''});
          //sets gradebook breadcrumbs
          this.$store.commit('instructors/setGradebookBreadcrumbs', gradebookBreadcrumbsCopy)
        }
        

        //creates interaction breadcrumbs and payload if interaction breadcrumb is clicked
        let breadcrumbCopy = [];
        if (!this.queryParamsInstructors?.isProquest) {
          breadcrumbCopy = [{text:this.gradebookBreadcrumbs[0].text,  payload: ''}];
        }
        let payload = {route:'instructor', activeView: 'Classes', activeViewRoute:'Interactions', queryParams:{section_id: this.queryParamsInstructors.section_id, bulb_id: this.queryParamsInstructors.bulb_id}, breadcrumb: breadcrumbCopy  }
        //calls setNavData
        this.setNavData(['Single-Interaction', {
          interaction_id: event.property,
          interaction_type: event.property_type,
          bulb_id: this.queryParamsInstructors.bulb_id,
          section_id: this.queryParamsInstructors.section_id,
          isProquest: this.queryParamsInstructors?.isProquest,
        } , null, [null, payload] ])
      }
    },
    studentInteractionNav:function(row,  interactionFlag){
      //nav for moving into bulb analysis for single student
      //copies gradebook breadcrumbs to be able to manipulate
      let gradebookBreadcrumbsCopy = {};
      /*
        If `this.queryParamsInstructors.isProquest` is true, then we don't show the breadcrumbs anyways. Since Proquest will most likely end up going directly to the monitor page (and thus their URLs won't have breadcrumbs), I felt it made sense to just sidestep this logic entirely.
      */
      if (!this.queryParamsInstructors?.isProquest) {
        gradebookBreadcrumbsCopy = this.gradebookBreadcrumbs.slice();
        //creates payload for gradebook breadcrumb to return to student bulb attempt view
        gradebookBreadcrumbsCopy[0].payload = "Student-Bulb-Attempts";
        //pushes bulb name breadcrumb into gradebookBreadcrumb copy
        if(interactionFlag){
          gradebookBreadcrumbsCopy.push({text:row.name, payload: 'Interactions'});
          //update breadcrumbs with interaction payload
          let breadcrumb = this.breadcrumbs;
          let payload = {Interactions:{route:'instructor', activeView: 'Classes', activeViewRoute:'Interactions', queryParams:{section_id: this.queryParamsInstructors.section_id, bulb_id: this.queryParamsInstructors.bulb_id}, breadcrumb: [{text:row.name, payload: ''}]}}
          this.$store.commit('updateBreadCrumbs' , [breadcrumb, payload]);
        } else {
          gradebookBreadcrumbsCopy.push({text:row.name, payload: ''});
        }

        //sets gradebook breadcrumbs
        this.$store.commit('instructors/setGradebookBreadcrumbs', gradebookBreadcrumbsCopy);
      }
      //creates student bulb attempt breadcrumb and payload if student bulb attempt breadcrumb is clicked
      let breadcrumbCopy = [];
      if (!this.queryParamsInstructors?.isProquest) {
        breadcrumbCopy = [{
          text: this.gradebookBreadcrumbs[0].text,
          payload: ''
        }];
      }
      let payload = {
        route:'instructor',
        activeView: 'Classes',
        activeViewRoute:'Student-Bulb-Attempts',
        queryParams: {
          section_id: this.queryParamsInstructors.section_id,
          student_id: this.queryParamsInstructors.student_id,
          isProquest: this.queryParamsInstructors?.isProquest,
        },
        breadcrumb: breadcrumbCopy,
      };

      //resets query params due to change in table structure and calls setNavData
      this.$store.commit('instructors/setQueryParams', {
        page:1,
        per_page: 20,
        sort:'',
        search: '',
        isProquest: this.queryParamsInstructors?.isProquest,
      });
      this.setNavData(['Student-Interaction', {
        student_id: this.queryParamsInstructors.student_id,
        section_id: this.queryParamsInstructors.section_id,
        isProquest: this.queryParamsInstructors?.isProquest,
        bulb_id: row.bulb_id
      }, null, [null, payload]]);
      if (this.queryParamsInstructors?.isProquest) this.$store.dispatch('instructors/updateUrl');
    },
    tableRowClassName ({row, rowIndex}) {
      if (row.bulb_role === 2) return 'co-owner';
      if (row.bulb_role === 3) return 'facilitator';
      return '';
    },
    lmbMonitorNav:function(data){
      //nav for moving into lmb monitor page

      //copies gradebook breadcrumbs to be able to manipulate
      let gradebookBreadcrumbsCopy = this.gradebookBreadcrumbs.slice();
      //creates payload for gradebook breadcrumb to return to full LMB view
      gradebookBreadcrumbsCopy[0].payload = "Learner-Made-Bulb";

      //pushes time breadcrumb into gradebookBreadcrumb copy
      gradebookBreadcrumbsCopy.push({text:`Monitor for ${data.student_name}`,  payload: ''});
      //sets gradebook breadcrumbs
      this.$store.commit('instructors/setGradebookBreadcrumbs', gradebookBreadcrumbsCopy)

      //creates lmb breadcrumbs and payload if lmb breadcrumb is clicked
      let breadcrumbCopy = [{text:this.gradebookBreadcrumbs[0].text,  payload: ''}]
      let payload = {route:'instructor', activeView: 'Classes', activeViewRoute:'Learner-Made-Bulb', queryParams:{section_id: this.queryParamsInstructors.section_id, bulb_id: this.queryParamsInstructors.bulb_id}, breadcrumb: breadcrumbCopy}
      //calls setNavData
      this.setNavData(['Learner-Made-Bulb-Monitor', {lmb_bulb: data.lmb_bulb_id, lmb_section: data.lmb_section_id} , null, [null, payload] ])
    },
    subfolderNav:function(data){
      //update breadcrumb folder name to be hotlink back to folder view
      let breadcrumbCopy = this.breadcrumbs.slice();
      let folder_name = breadcrumbCopy[1].text.slice();
      breadcrumbCopy.pop();
      breadcrumbCopy.push({text:folder_name, payload:'Folder'});
      breadcrumbCopy.push({text:data.name, payload: ''});
      let payload = {Folder:{route:'instructor', activeView: 'Folders', activeViewRoute:'Folder', queryParams:{ folder_id: this.queryParamsInstructors.folder_id}, breadcrumb: this.breadcrumbs }};
      this.$store.commit('updateBreadCrumbs' , [breadcrumbCopy, payload]);

      this.popoverReset = false;
      setTimeout(() => {this.popoverReset = true}, .5);

      this.$store.commit('instructors/clearAllFiltersNoReload');
      this.$store.commit('instructors/setQueryParams', {subfolder_id: data.id})
      this.$store.commit('instructors/setActiveView', ['Subfolder']);
      this.$store.dispatch('instructors/updateUrl');
    },

    //hotlink functions
    interactionHotlink: function(data){
      this.interactionByBulbNav(data);
    },
    gradeInteraction: function(interaction_id){
      this.$store.dispatch('sendManualLog',{category:'monitor', action:'grade all'});
      this.singleInteractionNav(interaction_id);
      this.toggleEditGrades(true);
    },
    gradeStudent: function(row){
      this.$store.dispatch('sendManualLog',{category:'monitor', action:'view student attempt'});
      row.bulb_id = this.queryParamsInstructors.bulb_id;
      if (this.gradebookBreadcrumbs.length) row.name = this.gradebookBreadcrumbs[0].text;
      if (!this.queryParamsInstructors?.isProquest) this.$store.commit('instructors/setGradebookBreadcrumbs', [{text:row.student_name,  payload: ''}]);

      this.$store.commit('instructors/setQueryParams', {student_id: row.id});
      this.toggleEditGrades(true);
      this.$store.commit('instructors/setActiveView', ['Student-Bulb-Attempts']);
      this.studentInteractionNav(row, null, {label:"Bulb Name"}, true);
    },
    interactionArray: function(id){
      return [parseInt(id,10)];
    },
    /** 
     * This function is sloppy and honestly is upsetting to read.
     * It handles sorting the tables when clicked.  Since I added keyboard events
     * it needed to be more specific and not just flip flop between ASC/DESC
     * 
     * @param event {
     *   column - the column from the table *not used in function or provided if event triggered by keyboardEvent*
     *   prop - the name of the data table prop used in the column
     *   order - 'ascending' (if from click) 'asc'/'desc' (from keyboardEvent)
     * }
    */
    sortChange: function(event) {
      if (
        !this.instructorAjaxing
        && this.selectedData.length === 0
      ) {
        let queryParams;
        if (
          this.queryParamsInstructors.sort === ''
          && event?.column
        ) {
          //if sort is not set, set sort to column prop ascending
          queryParams = { sort: `${ event.prop} ASC` };
        } else if (!event?.column) { // event triggered by keyboardEvent
          const order = event.order === 'ascending' ? 'ASC' : 'DESC';
          queryParams = { sort: `${ event.prop } ${ order }` };
        } else if (event.prop === null) {
          queryParams = { sort: '' };
        } else {
          //if sort is set, find name and order
          let name = this.queryParamsInstructors.sort.split(' ')[0];
          let order = this.queryParamsInstructors.sort.split(' ')[1];

          if (event.prop != name) {
            //if it is a new name, set sort to new column name ascending
            queryParams = { sort: `${event.prop} ASC` };
          } else if(event.prop === name && order === 'ASC') {
            //if it is the same column and asc, change to desc
            queryParams = { sort: `${event.prop} DESC` };
          } else if(event.prop === name && order === 'DESC') {
            //if it is the same column and desc, change to asc
            queryParams = { sort: `${event.prop} ASC` };
          }
        }
        //sets query params, calls data, and updates url
        this.$store.commit('instructors/setQueryParams', queryParams);
        if(this.activeViewInstructor != 'Premade-Bulbs' && this.activeViewInstructor != 'My-Community' && this.activeViewInstructor != 'Premade-Bulbs-Legacy' && this.activeViewInstructor != 'My-Community-Legacy'){
          this.$store.dispatch('instructors/getTableData');
        } else {
          this.$store.dispatch('instructors/getPremadeTableData', {});
        }
        this.$store.dispatch('instructors/updateUrl');
      }
    },


    //function to handle selection
    selectionChange:function(event){
      //stores selected data to state
      this.$store.commit('instructors/setSelectedData', event);
    },
    showTags:function(row){
      const rowTags = row?.tags || row?.playlistTags;
      if (
        rowTags.length > 3
      ) {
        this.showAllTags[row.id] ? this.showAllTags[row.id] = false : this.showAllTags[row.id] = true;
        this.updateTags = false;
        setTimeout(() => this.updateTags = true, .05);
      }
    },
    resetStudentBulbAttempt: function(data){
      this.$store.dispatch('sendManualLog',{category:'monitor', action:'reset bulb attempt'});
      this.$store.commit('instructors/setSelectedData', [data]);
      this.handleDialogOpen({type:'confirm', data:{type:'reset'}});
    },
    handleCurrentChange: function(val) {
        this.currentRow = val;
    },


    //functions to handle actions
    slideOutLarge:function(type, data){
      this.$store.commit('slideOut', {toggle:true, view:'peer-review', data:data})
    },
    edit: function(id) {
      if(this.activeViewInstructor === 'Bulbs'){
        this.$store.dispatch('sendManualLog',{category:'bulbs', action:'edit bulb'});
      }
      this.setDashModal({
        type: 'confirmEditBulb',
        designerURL: `${this.designerApiPrefix}/designer/?bulb_id=${id}&token=${this.instructorData.token}&lms_launch=${this.LTIlaunch}`,
      });
    },
    archive:function(array){
      let id = array[0];
      let name = array[1];
      // if archive class, confirms, calls archive class function
      if(confirm(`Would you like to archive "${name}"?`)){
        this.$store.dispatch('instructors/archiveClass', id);
      }
    },
    archiveVideo:function(array){
      let id = array[1];
      let name = array[0];
      // if archive class, confirms, calls archive class function
      if(confirm(`Are you sure you would like to remove "${name}" from My Videos?`)){
        this.$store.dispatch('instructors/archiveVideo', id);
      }
    },
    buildVideoBulb:function(id){
      //opens editor
      this.$store.dispatch('sendManualLog',{category:'video', action:'build video into bulb'});
      window.open(`${this.designerApiPrefix}/designer/?bulb_id=new&token=${this.instructorData.token}&video_id=${id}&lms_launch=${this.LTIlaunch}`);
    },
    copyLMB: function (data) {
      this.$store.commit('instructors/toggleToastLoader', {
        toggle: true,
        text: 'Copying Bulb',
      });
      this.$store.dispatch('instructors/copyBulb', {
        id: data.lmb_id,
        name: `Copy of ${data.firstName}'s Peer Review submission for ${data.lmb_name}`,
        edit: false,
        lti: false,
        fullCopy: true,
        isCopyingUnrestricted: true,
        copyLmbData: false,
      });
    },
    play:function(bulb){
      //opens player
      this.$store.dispatch('sendManualLog',{category:'my bulbs', action:'preview'});
      window.open(`${this.playerApiPrefix}/player_v2/?type=share&bulb_id=${bulb.id}&token=${this.instructorData.token}&lms_launch=${this.LTIlaunch}`);
    },
    playLMB: function(data){
      this.$store.dispatch('sendManualLog',{category:'lmb', action:'preview'});
      window.open(`${this.playerApiPrefix}/player_v2/?section_id=${data.section_id}&type=share&bulb_id=${data.id}&token=${this.instructorData.token}&lms_launch=${this.LTIlaunch}`);
    },
    playAuth:function(bulb){
      //opens player
      this.$store.dispatch('sendManualLog',{category:'bulbs', action:'preview'});
      window.open(`${this.playerApiPrefix}/player_v2/?section_id=${this.queryParamsInstructors.section_id}&type=share&bulb_id=${bulb.id}&token=${this.instructorData.token}&lms_launch=${this.LTIlaunch}`);
    },
    playPremade:function(id){
      if(this.activeViewInstructor === "Premade-Bulbs-Legacy" || this.activeViewInstructor === "My-Community-Legacy"){
        window.open(`https://api.playposit.com/player/?lesson_id=${id}&token=${this.instructorData.token}`)
      } else {
        window.open(`${this.playerApiPrefix}/player_v2/?type=share&bulb_id=${id}&token=${this.instructorData.token}&lms_launch=${this.LTIlaunch}`)
      }
    },
    saveGrade: function(points,  interaction_attempt_id, explanation, student_id, bulb_attempt_id){
      //saves grade based on grade view
      if(this.activeViewInstructor === "Single-Interaction") {
        this.$store.dispatch('sendManualLog',{category:'monitor', action:'save grade from grade all'});
        //if in single interaction, creates data, changes explanation_graded_single object, calls updateGrades
        let data = {points_earned: points, interaction_attempt_id: interaction_attempt_id, explanation: explanation}
        this.explanation_graded_single[student_id] = points;
        this.$store.dispatch('instructors/updateGrades', data);
      }

      if (this.activeViewInstructor === "Student-Interaction"){
        this.$store.dispatch('sendManualLog',{category:'monitor', action:'save grade from student view'});
        //if in student view, creates data, changes explanation_grade_student object, and calls updateGrades
        let data = {points_earned: points, interaction_attempt_id: interaction_attempt_id, explanation: explanation}
        this.explanation_grade_student[interaction_attempt_id] = points;
        this.$store.dispatch('instructors/updateGrades', data);
      }

      if (this.activeViewInstructor === 'Interactions' || this.activeViewInstructor === 'Learner-Made-Bulb-Monitor'){
        this.$store.dispatch('sendManualLog',{category:'monitor', action:'save grade from interactions'});
        let data = {points_earned: points, interaction_attempt_id: interaction_attempt_id, explanation: explanation};
        this.$store.dispatch('instructors/updateGrades', data);
      }
      //reload interaction viewer
      this.$store.commit('instructors/reloadInteractionViewerIdToggle', interaction_attempt_id);
      this.$store.commit('instructors/setSavedGrade', interaction_attempt_id);
    },
    toggleOnViewer: function(interaction_attempt_id){
      this.interactionAttemptShow = `${this.activeViewInstructor}-${interaction_attempt_id}`;
      this.footerCounter += 1;
    },
    debouncedSaveLMBGrade: _.debounce(function({
      bulb_attempt,
      points_earned,
      points_available,
      row,
    } = {}) {
      let pointsEarned = points_earned;
      if (!_.isFinite(pointsEarned)) return;
      if (pointsEarned < 0) {
        pointsEarned = 0;
      } else if (pointsEarned > points_available) {
        pointsEarned = points_available;
      }
      this.$set(row, 'points_earned', pointsEarned);
      this.saveLMBGrade({
        bulb_attempt,
        points_earned: pointsEarned,
        points_available,
      });
    }, 500, {
      leading: false,
      trailing: true,
    }),
    saveLMBGrade: function(data){
      this.$store.dispatch('instructors/updateLMBGrade', data);
      if(this.activeViewInstructor === "Learner-Made-Bulbs"){
        this.lmb.data.map(item => {
          if(item.bulbattempt_id === data.bulb_attempt){
            let score = ((data.points_earned / item.points_available) * 100).toFixed(0) ;
            item.score = `${score}%`
          }
        })
      } else {
        this.peerreview.data.map(item => {
          if(item.bulb_attempt_id === data.bulb_attempt_id){
            let score = ((data.points_earned / item.points_available) * 100).toFixed(0) ;
            item.score = `${score}%`
            return item;
          }
        })
      }
    },
    newBulb: function(){
      window.open(`${this.nodeApiPrefix}/designer/?bulb_id=new&token=${this.instructorData.token}&lms_launch=${this.LTIlaunch}`);
    },
    premadeCreatorSearch: function(id, name){
      //reset query params and update url
      this.$store.commit('instructors/resetQueryParams');
      this.$store.dispatch('instructors/updateUrl');

      this.$store.dispatch('instructors/getPremadeTableData', {teacher_id: id, teacher_name: name});
    },
    activateBulb: function(data){
      this.$store.commit('instructors/toggleToastLoader', {toggle: true, text: 'Activating Bulb'});
      this.$store.dispatch('instructors/activateBulb', {bulb_id: data.id, lesson_id: data.root_lesson_id});
    },
    openInteractionModal: function(question){
      this.$store.dispatch('sendManualLog',{
        category:'monitor',
        action:'interaction data',
      });
      const formattedQuestion  = this.questionFormat(question) // refactor to use InteractionReview in the future
      const sectionId = this.activeViewInstructor === 'Interactions'
        ? this.queryParamsInstructors.section_id
        : this.queryParamsInstructors.lmb_section;
      this.$el.click();
      this.$store.commit('slideOut', {
        toggle:true,
        view:'interactionData', 
        data: {
          interaction: question,
          interactionHtml: formattedQuestion.questionHTML,
          sectionId,
        }
      });
    },
    setKeywordFilter: function(tag) {
      //reset query params and update url
      this.$store.commit('instructors/setQueryParams', {sort:'', page:1, per_page:20, search: ''});
      this.$store.dispatch('instructors/updateUrl');
      let obj = { ...this.filterSearch, legacy: false }
      if(tag.type === 'age'){
        obj.age.push(tag.text);
      } else if (tag.type === 'subject'){
        obj.subject.push(tag.text);
      } else if (tag.type === 'user-generated'){
        obj.keywords.push(tag.text);
      }
      // If you click on the tag, it's implicitly expected that you're looking for that exact tag.
      // So default to always searching for exact match.
      obj.tagExactMatch = true;
      this.$store.commit('instructors/setFilters', obj);
    },
    //set max height on mount
    setMaxHeight: function() {
      let offset = window.innerWidth < 900 ? 240 : (this.filtersOn) ? 263 : 225;
      if (this.migrationBannerShowing) offset += 50;
      this.maxHeight =  ((window.innerHeight - offset) < 300) ? offset : (window.innerHeight - offset);
    },
    //functions to add css classes to columns and rows
    sortClasses: function(event){
      if(!this.instructorAjaxing && this.selectedData.length === 0){
        let sortArray = this.queryParamsInstructors.sort.split(" ");
        //changes header class based on sort
        let sortClass;
        if(_.snakeCase(event.column.property) === sortArray[0]){
          //returns class based on desc or asc sort to change arrow color
          (sortArray[1] === 'DESC') ? sortClass= 'descSelected' : sortClass= 'ascSelected';
          return sortClass;
        } else {
          //if no sort, return noSelected class
          return 'noSelected';
        }
      }
    },
    gradebookSortClasses:function(event){
      const gradebookColumnIndex = this.isPlaylistGradebook ? 1 : 0;
      if (
          (
            event.rowIndex == 0
            && event.columnIndex == gradebookColumnIndex
          )
          || ( // This prevents the second column's header (Instructor School) text from being blue. Applies only if feature flag is toggled
            event.columnIndex == 1
            && this.hasInstructorLearnerSchoolInGradebook
        ) 
      ) {
        //if first column
        if(!this.instructorAjaxing && this.selectedData.length === 0){
          let sortArray = this.queryParamsInstructors.sort.split(" ");
          //changes header class based on sort
          let sortClass;
          if(event.column.property === sortArray[0]){
            //returns class based on desc or asc sort to change arrow color
            (sortArray[1] === 'DESC') ? sortClass= 'descSelected' : sortClass= 'ascSelected';
            return sortClass;
          } else {
            //if no sort, return noSelected class
            return 'noSelected';
          }
        }
      } else {
          // If playlist gradebook, find the module items that are bulbs and change the column header to be selectable
          if (gradebookColumnIndex === 1){
            let array1 = []
            this.gradebook.headers.forEach(item => {
              if(item.p_item_type === 'bulb'){
                array1.push(item.p_item_id)
              }
            })
            if (array1.includes(event.column.property)){
              return 'selectable';
            }
          } else {
            //if not first column, returns selectable
            return 'selectable';
          }
      }
    },
    columnClass:function(event){
      if(event.columnIndex == 0){
        //returns selectable class for student side of gradebook
        return 'selectable';
      }
    },
    thumbnailColumn:function(event){
      if(event.columnIndex == 0){
        //if thumbnail, returns no-padding class
        return 'no-padding';
      }
    },
    rowHeight:function(event){
      //sets row height to 40 in student interaction table
      return 'row-height'
    },
    tagStyle: function(data){
      let color = (data.color) ? data.color : '#FAFAFA';
      let darkColor = Color(color).darken(0.60).hex();
      return {
        'backgroundColor': color,
        'color': darkColor,
        'border': `solid 1px ${darkColor}`,
        'borderRadius': '20px',
        'cursor': 'pointer'
      }
    },
    questionFooterPointsStyle: function(points_earned, points_available){
      if(points_available == 0) {
        return {
          'color': '#858585',
        }
      } else if(points_earned === null){
        return {
          'color': '#fbbc04',
        }
      } else if(points_earned == 0){
        return {
          'color': '#ea4335'
        }
      } else {
        return {
          'color': '#34a853'
        }
      }
    },
    gradebookDate: function(date){
      if(!date){
        return ''
      } else {
        return moment(date, "MMM DD, YYYY").format("MMM DD, YYYY");
      }
    },
    
    //functions to format table cells and headers
    questionFormat: function(data) {
      let questionObject = {};

      switch(data.interaction_type) {
        case INTERACTION_TYPES.MULTIPLE_CHOICE:
          questionObject.type = 'Multiple Choice';
          questionObject.icon = 'format_list_bulleted';

          //create list items for answers and feedback
          let answerArrayMC= [];
          if(data.interaction_options.length > 0){
            data.interaction_options.forEach((answer, i) => {
              if(answer.correct === 1){
                (answer.feedback === null || answer.feedback === '') ? answerArrayMC.push(`<li><span class="dot-correct"></span>${answer.option}</li>`) : answerArrayMC.push(`<li><span class="dot-correct"></span>${answer.option}</li><li class='feedback'><span style="margin-right: 5px; font-weight:bold;">Feedback:</span><span> ${answer.feedback}</span></li>`);
              } else {
                (answer.feedback === null || answer.feedback === '') ? answerArrayMC.push(`<li><span class="dot-incorrect"></span>${answer.option}</li>`) : answerArrayMC.push(`<li><span class="dot-incorrect"></span>${answer.option}</li><li class='feedback'><span style="margin-right: 5px; font-weight:bold;">Feedback:</span><span>${answer.feedback}</span></li>`);
              }
            })
          }
          //join list items and add to questionHTML
          let answersMC = answerArrayMC.join(' ');
          questionObject.questionHTML = `<div class="question-format"><div class="question-text">${data.interaction_text}</div></div><div class="question-format"><ul>${answersMC}</ul></div>`

          break;
        case INTERACTION_TYPES.CHECK_ALL_APPLY:
          questionObject.type = 'Check All';
          questionObject.icon = 'playlist_add_check';

            //create list items for answers and feedback
            let answerArrayCA= [];
          if(data.interaction_options.length > 0){
            data.interaction_options.forEach((answer, i) => {
              if(answer.correct === 1){
                (answer.feedback === null || answer.feedback === '') ? answerArrayCA.push(`<li><span class="dot-correct"></span>${answer.option}</li>`) : answerArrayCA.push(`<li><span class="dot-correct"></span>${answer.option}</li><li class='feedback'><span style="margin-right: 5px; font-weight:bold;">Feedback:</span> ${answer.feedback}</li>`);
              } else {
                (answer.feedback === null || answer.feedback === '') ? answerArrayCA.push(`<li><span class="dot-incorrect"></span>${answer.option}</li>`) : answerArrayCA.push(`<li><span class="dot-incorrect"></span>${answer.option}</li><li class='feedback'><span style="margin-right: 5px; font-weight:bold;">Feedback:</span> ${answer.feedback}</li>`);
              }
            })
          }
            //join list items and add to questionHTML
            let answersCA = answerArrayCA.join(' ');
            questionObject.questionHTML = `<div class="question-format"><div class="question-text">${data.interaction_text}</div></div><div class="question-format"><ul>${answersCA}</ul></div>`

          break;
        case INTERACTION_TYPES.FREE_RESPONSE:
          questionObject.type = 'Free Response';
          questionObject.icon = 'border_color';
          questionObject.questionHTML = `<div class="question-format"><div class="question-text">${data.interaction_text}</div></div>`
          if(data.config){
            if(data.config.feedback){
              questionObject.questionHTML += `<ul style="list-style: none"><li class='feedback'><span style="margin-right: 5px; font-weight:bold;">Feedback:</span> ${data.config.feedback}</li></ul>`
            }
          }
          break;
        case INTERACTION_TYPES.SHORT_ANSWER:
          questionObject.type = 'Fill in the blank';
          questionObject.icon = 'subtitles';

            let answerArraySA= [];
          if(data.interaction_options.length > 0){
            data.interaction_options.forEach((answer, i) => {
              if(answer.feedback === null || answer.feedback === '' ){
                answerArraySA.push(`<li><i data-v-48ddbe66="" aria-hidden="true" class="v-icon material-icons theme--light" style="margin-right:10px;">subtitles</i>${answer.option}</li>`);
              } else {
                answerArraySA.push(`<li><i data-v-48ddbe66="" aria-hidden="true" class="v-icon material-icons theme--light" style="margin-right:10px;">subtitles</i>${answer.option}</li><li class='feedback'><span style="margin-right: 5px; font-weight:bold;">Feedback:</span> ${answer.feedback}</li>`);
              }
            })
          }
            let answersSA = answerArraySA.join(' ');
            let question = data.interaction_text.replace(/fill in blank/g,'______________________');
            questionObject.questionHTML = `<div class="question-format"><div class="question-text">${question}</div></div><div class="question-format"><ul>${answersSA}</ul></div>`

          break;
        case INTERACTION_TYPES.PAUSE:
          questionObject.type = 'Pause';
          questionObject.icon = 'bookmark_border';
          questionObject.questionHTML = `<div class="question-format"><div class="question-text">${data.interaction_text}</div></div>`

          break;
        case INTERACTION_TYPES.IFRAME:
          questionObject.type = 'Embedded';
          questionObject.icon = 'public';
          if(this.activeViewInstructor === 'Interactions'){
            questionObject.questionHTML = `<div class="question-modal-iframe"><iframe src="${decodeURIComponent(data.interaction_text)}"></iframe></div>`
          } else {
            questionObject.questionHTML = `<div class="question-iframe"><iframe src="${decodeURIComponent(data.interaction_text)}"></iframe></div>`
          }


          break;
        case INTERACTION_TYPES.FILE_VIEWER:
          questionObject.type = 'PDF Viewer';
          questionObject.icon = 'picture_as_pdf';
          if(this.activeViewInstructor === 'Interactions'){
            questionObject.questionHTML = `<div class="question-modal-iframe"><iframe src="${decodeURIComponent(data.interaction_text)}"></iframe></div>`
          } else {
            questionObject.questionHTML = `<div class="question-iframe"><iframe src="${decodeURIComponent(data.interaction_text)}"></iframe></div>`
          }

          break;
        case 'poll_q':
          questionObject.type = 'Poll';
          questionObject.icon = 'poll';

          let answerArrayP= [];
          if(data.interaction_options.length > 0){
            data.interaction_options.forEach((answer, i) => {
            if(answer.feedback === null || answer.feedback === ''){
                answerArrayP.push(`<li><span class="dot-incorrect"></span>${answer.option}</li>`);
              } else {
                answerArrayP.push(`<li><span class="dot-incorrect"></span>${answer.option}</li><li class='feedback'><span style="margin-right: 5px; font-weight:bold;">Feedback:</span> ${answer.feedback}</li>`);
              }
            })
          }
            let answersP = answerArrayP.join(' ');
            questionObject.questionHTML = `<div class="question-format"><div class="question-text">${data.interaction_text}</div></div><div class="question-format"><ul>${answersP}</ul></div>`
          break;
        case 'discussion_q':
          questionObject.type = 'Discussion';
          questionObject.icon = 'chat';
          questionObject.questionHTML = `<div class="question-format"><div class="question-text">${data.interaction_text}</div></div>`
          break;
        default:
          questionObject.type = 'Question';
          questionObject.icon = 'question_answer';
          break;
      }

      return questionObject;
    },
    handleProquestBulbDeletionData(bulbId) {
      if (this.$route.name !== 'instructor') return;
      let proquestBulbIds;
      if (this.selectedData?.length) {
        proquestBulbIds = this.selectedData
          .filter((bulb) => bulb.isProquestBulb)
          .map((bulb) => bulb.id);
      } else if (bulbId) {
        const match = this.bulbs.data.find((bulb) => (
          bulb.id === bulbId
          && bulb.isProquestBulb
        ));
        if (match) proquestBulbIds = [bulbId];
      }
      if (!proquestBulbIds.length) return;
      for (const bulbId of proquestBulbIds)  {
        this.sendProquestData({
          id: bulbId,
          type: 'bulb',
          event: 'delete',
          skipCallback: true,
        });
      }
    },
    addListeners:function(){
      window.addEventListener('resize', this.adjustMaxHeight);
      EventBus.$on('sendProquestBulbDeletionData', this.handleProquestBulbDeletionData);
    },
    removeListeners:function(){
      window.removeEventListener('resize', this.adjustMaxHeight);
      EventBus.$off('sendProquestBulbDeletionData', this.handleProquestBulbDeletionData);
    },
    adjustMaxHeight: function(event){
      this.setMaxHeight();
    },
    rowTags(content) {
      const filteredTags = [];
      const contentTags = this.isPremadePlaylists ? content.playlistTags : content.tags;
      contentTags.forEach((contentTag, index) => {
        let tagData;
        if (!this.isPremadePlaylists) { // Bulbs
          tagData = {
            color: contentTag.color,
            type: contentTag.type,
            text: contentTag.text,
          };
        } else { // Playlists
          tagData = {
            color: contentTag.tag.hex,
            type: contentTag.tag.type,
            text: contentTag.text ? contentTag.text : contentTag.tag.value,
            tagId: contentTag.tagId,
          };
        }
        if (
          !this.showAllTags[content.id]
          && index <= 2
        ) filteredTags.push(tagData)
        else if (this.showAllTags[content.id]) filteredTags.push(tagData);
      });
      return filteredTags;
    },
  },
  watch: {
    activeViewData: {
      handler: async function(val, oldVal){
        //watcher for grade changes in radio buttons
        if(val[0] === "Single-Interaction" && val[1]){
          this.singleinteraction.data.forEach((item, i)=> this.$set(this.explanation_graded_single, item.id, item.explanation_graded));
        } else if(val[0] === "Student-Interaction" && val[1]) {
          this.studentinteraction.data.forEach((item, i)=> this.$set(this.explanation_grade_student, item.interaction_attempt_id,  item.explanation_graded));
        }

        if(val[0] != oldVal[0]){
          this.interactionAttemptShow = null;
        }
        if (val[1]) {
          const caretWrapper = await waitForElementToDisplay('.caret-wrapper');
          if (caretWrapper) addSortAccessibiltyEvents(this.sortChange, this.activeView, this.activeViewInstructor); // val[1] = dynamicDataLoaded
        }
      }
    },
    selectedData: {
      handler: function(val){
        if(val.length === 0){
          if(this.$refs.studentClassTable){
            this.$refs.studentClassTable.clearSelection();
          }
        }
        if (
          val.length > 50
          && (
            this.activeViewInstructor === 'My-Bulbs'
            || this.activeViewInstructor === 'Bulbs'
          )
        ){
          this.triggerSnackbar({text:"Only 50 bulbs can be selected at a time.  Please select 50 or less and try again.", color: 'warning', timeout: 6000});
        }
      }
    },
    showPointMode (n, o) {
      if (n) this.gradebookTableKey += 1;
    },
    refreshData: {
      handler: function(val){
        if(val){
          this.$store.commit('instructors/refreshComplete');
          if(this.activeViewInstructor != 'Premade-Bulbs' && this.activeViewInstructor != 'My-Community' && this.activeViewInstructor != 'Premade-Bulbs-Legacy' && this.activeViewInstructor != 'My-Community-Legacy'){
            this.$store.dispatch('instructors/getTableData');
          } else {
            this.$store.dispatch('instructors/getPremadeTableData', {});
          }
          this.setSelectedData([]);
        }
      }
    },
    editGrades: {
      handler: function(val, oldVal){
        if(!val && oldVal){
          this.$store.commit('instructors/refreshData');
        }
      }
    },
    filtersOn: {
      handler: function() {
        this.setMaxHeight();
      }
    },
    modalOpen: {
      handler: function(val){
        //close table popovers from hotlinks
        if(val){
          this.popoverReset = false;
          setTimeout(() => {this.popoverReset = true}, .0000001);
        }
      }
    },
    menus: {
      handler(n, o) {
        for (const key in n) {
          for (const innerKey in n[key]) {
            if (n[key][innerKey]) {
              this.menuData[key][innerKey] = true;
            }
          }
        }
      },
      deep: true,
    },
  },
  async created() {
    if (
      this.activeViewInstructor === 'Interactions'
      && this.$route.query.embed
    ) {
      this.$store.commit('instructors/setQueryParams', { embed: true });
    }
    this.setMaxHeight();
    if (
      this.isProquestUser
      && [
        '/dash/instructor/Classes/Interactions',
        '/dash/instructor/Classes/Interactions/',
      ].includes(this.$route.path)
    ) {
      this.$store.commit('instructors/setFiltersInteractions', {
        selectedStatus: 'All',
        showPointsBadges: true,
        localShowPointsBadges: true,
        isFiltered: true,
        refreshData: this.filtersInteraction.selectedStatus !== 'All',
      });
    }
  },
  mounted(){
    this.setMaxHeight();
    this.addListeners();
  },
  beforeDestroy(){
    this.removeListeners();
  }
};
</script>

<style scoped>
  .free-response-wrapper {
    display: flex;
    justify-content: flex-start;
    align-items: center;
  }

  #instructor-table-dynamic{
   width: 100%;
   padding: 0px 36px;
   margin-top: -5px;
  }

  .grade-drop-down {
    z-index: 1 !important;
  }

  .bulbPickerIcon {
    -webkit-transform: rotate(180deg);
    -moz-transform: rotate(180deg);
    -ms-transform: rotate(180deg);
    -o-transform: rotate(180deg);
    transform: rotate(180deg);
  }
  
  /* v-btn flat text */
  .gradebookAverageScore {
    margin-top: 2px;
    margin-bottom: 0px;
    line-height: 16px;
    padding-bottom: 5px;
  }
  .centerHeaderStyle {
    padding-top: 9px;
    margin-bottom: 0px !important;
  }
  .playlistScore {
    margin-top: -14px;
  }

  .orange-border {
    border-color: orange !important;
  }
</style>


